<template>
  <div class="cmpDivMaster">
    <div class="cmpContainerParent">
      <!-- ########################################## -->
      <!-- --------------- SEARCH ------------------- -->
      <!-- ########################################## -->

      <div v-if="enableSearching || showSettingsIcon" class="xxyyspaced">

        <!-- cccccccccccccccccccc ROWS PER PAGE -->

        <div v-if="!enablePaging">&nbsp;</div>
        
        <div v-if="enablePaging" style="align-content: left; text-align: left;" >

          <div style="display: flex; flex-direction: row; flex-wrap: nowrap;">

            <div style="display: inline-block; margin-right: 10px;">Show</div>

            <select class="form-select form-select-sm pgeSelectSizing pgeMarginZero pgeDivboxPadding" id="xcmpxRowsPerPage_ID"
              @change="rowsPerPageOnchange" v-model="rppSelected" aria-label="Select the number of rows to be displayed">
              <option v-for="item in rppArray" :value="item.records" :key="item.display">
               {{ item.display }}
              </option>
            </select>

            <span style="margin-left: 10px;">{{ rowsPerPageText }}</span>

          </div>

        </div>
        <!-- cccccccccccccccccccc END -->

        <!-- ---------------------------------------------------------------------- -->
        <!-- ---------------------- Search Controls Settings ---------------------- -->
        <!-- ---------------------------------------------------------------------- -->
        <div style="align-content: right; text-align: right;">
          <div style="display: inline-block; margin-right: 5px;">{{ searchText }}</div>

          <div style="display: inline-block">
            <div class="srcJustify-Content-Left">

              <div v-if="enableSearching" class="srcMarginRightLarge">
                <input id="xcmpxDynSearchInputID" 
                       v-on:input="handleSearchEvent($event)" 
                       :value="searchString"
                       type="search" aria-label="Enter a string to filter the records returned" />
              </div>

              <span v-if="showSettingsIcon && settingsActive" style="color: blue;">(s)</span>

              <div v-if="showSettingsIcon" 
                  @click="handleOpenSettingsModal()"
                  class="material-icons-outlined forIconSearch" 
                  data-tooltip="tooltip" 
                  title=" Show Control Settings"
                  data-bs-toggle="modal" 
                  data-bs-target="#editModal">
                settings
              </div>

            </div>
          </div>

        </div>

      </div>

      <!-- ########################################## -->
      <!-- ------------------ GRID ------------------ -->
      <!-- ########################################## -->

      <div class="grdDivMarginTop">
        <table class="table table-striped">

          <!-- ------------------------------- -->
          <!-- --------- Header --------------- -->
          <!-- -------------------------------- -->

          <thead>
            <tr>
              
              <!-- ==================================================================== -->
              <!-- ============================ Left Header =========================== -->
              <!-- ==================================================================== -->
              <!-- --------- Left Slot Header - 0 ---------------- -->
              <th class="grdHeader" @click="handleSlotSort('leftHeader0')" :class="{
                grdSortHeader: (enableSorting == true) && (enableSlotSorting.get('leftHeader0')),
                xcmpxmodalFontSmaller: headerFontSmaller == true,
                xcmpxmodalFontSmall: headerFontSmall == true,
                xcmpxmodalFontMedium: headerFontMedium == true,
                xcmpxmodalFontLarge: headerFontLarge == true,
                xcmpxmodalFontLarger: headerFontLarger == true
              }" style="white-space: nowrap;"
                v-if="$slots.leftHeader0">

                <slot name="leftHeader0"></slot>

                <img v-if="
                  selectedSlotName == 'leftHeader0' &&
                  useAscendingSort &&
                  enableSorting && enableSlotSorting.get('leftHeader0')
                " src="@/assets/images/sort_up.png" class="grdImageSizer" alt="" />
                <img v-if="
                  selectedSlotName == 'leftHeader0' &&
                  !useAscendingSort &&
                  enableSorting && enableSlotSorting.get('leftHeader0')
                " src="@/assets/images/sort_down.png" class="grdImageSizer" alt="" />
                <img v-if="selectedSlotName != 'leftHeader0' && enableSorting && enableSlotSorting.get('leftHeader0')"
                  src="@/assets/images/sort_neither.png" class="grdImageSizer" alt="" />

              </th>
              <!-- --------- Left Slot Header - 1 ---------------- -->
              <th class="grdHeader" @click="handleSlotSort('leftHeader1')" :class="{
                grdSortHeader: (enableSorting == true) && (enableSlotSorting.get('leftHeader1')),
                xcmpxmodalFontSmaller: headerFontSmaller == true,
                xcmpxmodalFontSmall: headerFontSmall == true,
                xcmpxmodalFontMedium: headerFontMedium == true,
                xcmpxmodalFontLarge: headerFontLarge == true,
                xcmpxmodalFontLarger: headerFontLarger == true
              }" style="white-space: nowrap;"
                v-if="$slots.leftHeader1">

                <slot name="leftHeader1"></slot>

                <img v-if="
                  selectedSlotName == 'leftHeader1' &&
                  useAscendingSort &&
                  enableSorting && enableSlotSorting.get('leftHeader1')
                " src="@/assets/images/sort_up.png" class="grdImageSizer" alt="" />
                <img v-if="
                  selectedSlotName == 'leftHeader1' &&
                  !useAscendingSort &&
                  enableSorting && enableSlotSorting.get('leftHeader1')
                " src="@/assets/images/sort_down.png" class="grdImageSizer" alt="" />
                <img v-if="selectedSlotName != 'leftHeader1' && enableSorting && enableSlotSorting.get('leftHeader1')"
                  src="@/assets/images/sort_neither.png" class="grdImageSizer" alt="" />

              </th>
              <!-- --------- Left Slot Header - 2 ---------------- -->
              <th class="grdHeader" @click="handleSlotSort('leftHeader2')" :class="{
                grdSortHeader: (enableSorting == true) && (enableSlotSorting.get('leftHeader2')),
                xcmpxmodalFontSmaller: headerFontSmaller == true,
                xcmpxmodalFontSmall: headerFontSmall == true,
                xcmpxmodalFontMedium: headerFontMedium == true,
                xcmpxmodalFontLarge: headerFontLarge == true,
                xcmpxmodalFontLarger: headerFontLarger == true
              }" style="white-space: nowrap;"
                v-if="$slots.leftHeader2">

                <slot name="leftHeader2"></slot>

                <img v-if="
                  selectedSlotName == 'leftHeader2' &&
                  useAscendingSort &&
                  enableSorting && enableSlotSorting.get('leftHeader2')
                " src="@/assets/images/sort_up.png" class="grdImageSizer" alt="" />
                <img v-if="
                  selectedSlotName == 'leftHeader2' &&
                  !useAscendingSort &&
                  enableSorting && enableSlotSorting.get('leftHeader2')
                " src="@/assets/images/sort_down.png" class="grdImageSizer" alt="" />
                <img v-if="selectedSlotName != 'leftHeader2' && enableSorting && enableSlotSorting.get('leftHeader2')"
                  src="@/assets/images/sort_neither.png" class="grdImageSizer" alt="" />

              </th>
              <!-- --------- Left Slot Header - 3 ---------------- -->
              <th class="grdHeader" @click="handleSlotSort('leftHeader3')" :class="{
                grdSortHeader: (enableSorting == true) && (enableSlotSorting.get('leftHeader3')),
                xcmpxmodalFontSmaller: headerFontSmaller == true,
                xcmpxmodalFontSmall: headerFontSmall == true,
                xcmpxmodalFontMedium: headerFontMedium == true,
                xcmpxmodalFontLarge: headerFontLarge == true,
                xcmpxmodalFontLarger: headerFontLarger == true
              }" style="white-space: nowrap;"
                v-if="$slots.leftHeader3">

                <slot name="leftHeader3"></slot>

                <img v-if="
                  selectedSlotName == 'leftHeader3' &&
                  useAscendingSort &&
                  enableSorting && enableSlotSorting.get('leftHeader3')
                " src="@/assets/images/sort_up.png" class="grdImageSizer" alt="" />
                <img v-if="
                  selectedSlotName == 'leftHeader3' &&
                  !useAscendingSort &&
                  enableSorting && enableSlotSorting.get('leftHeader3')
                " src="@/assets/images/sort_down.png" class="grdImageSizer" alt="" />
                <img v-if="selectedSlotName != 'leftHeader3' && enableSorting && enableSlotSorting.get('leftHeader3')"
                  src="@/assets/images/sort_neither.png" class="grdImageSizer" alt="" />

              </th>
              <!-- --------- Left Slot Header - 4 ---------------- -->
              <th class="grdHeader" @click="handleSlotSort('leftHeader4')" :class="{
                grdSortHeader: (enableSorting == true) && (enableSlotSorting.get('leftHeader4')),
                xcmpxmodalFontSmaller: headerFontSmaller == true,
                xcmpxmodalFontSmall: headerFontSmall == true,
                xcmpxmodalFontMedium: headerFontMedium == true,
                xcmpxmodalFontLarge: headerFontLarge == true,
                xcmpxmodalFontLarger: headerFontLarger == true
              }" style="white-space: nowrap;"
                v-if="$slots.leftHeader4">

                <slot name="leftHeader4"></slot>

                <img v-if="
                  selectedSlotName == 'leftHeader4' &&
                  useAscendingSort &&
                  enableSorting && enableSlotSorting.get('leftHeader4')
                " src="@/assets/images/sort_up.png" class="grdImageSizer" alt="" />
                <img v-if="
                  selectedSlotName == 'leftHeader4' &&
                  !useAscendingSort &&
                  enableSorting && enableSlotSorting.get('leftHeader4')
                " src="@/assets/images/sort_down.png" class="grdImageSizer" alt="" />
                <img v-if="selectedSlotName != 'leftHeader4' && enableSorting && enableSlotSorting.get('leftHeader4')"
                  src="@/assets/images/sort_neither.png" class="grdImageSizer" alt="" />

              </th>
              <!-- --------- Left Slot Header - 5 ---------------- -->
              <th class="grdHeader" @click="handleSlotSort('leftHeader5')" :class="{
                grdSortHeader: (enableSorting == true) && (enableSlotSorting.get('leftHeader5')),
                xcmpxmodalFontSmaller: headerFontSmaller == true,
                xcmpxmodalFontSmall: headerFontSmall == true,
                xcmpxmodalFontMedium: headerFontMedium == true,
                xcmpxmodalFontLarge: headerFontLarge == true,
                xcmpxmodalFontLarger: headerFontLarger == true
              }" style="white-space: nowrap;"
                v-if="$slots.leftHeader5">

                <slot name="leftHeader5"></slot>

                <img v-if="
                  selectedSlotName == 'leftHeader5' &&
                  useAscendingSort &&
                  enableSorting && enableSlotSorting.get('leftHeader5')
                " src="@/assets/images/sort_up.png" class="grdImageSizer" alt="" />
                <img v-if="
                  selectedSlotName == 'leftHeader5' &&
                  !useAscendingSort &&
                  enableSorting && enableSlotSorting.get('leftHeader5')
                " src="@/assets/images/sort_down.png" class="grdImageSizer" alt="" />
                <img v-if="selectedSlotName != 'leftHeader5' && enableSorting && enableSlotSorting.get('leftHeader5')"
                  src="@/assets/images/sort_neither.png" class="grdImageSizer" alt="" />

              </th>
              <!-- --------- Left Slot Header - 6 ---------------- -->
              <th class="grdHeader" @click="handleSlotSort('leftHeader6')" :class="{
                grdSortHeader: (enableSorting == true) && (enableSlotSorting.get('leftHeader6')),
                xcmpxmodalFontSmaller: headerFontSmaller == true,
                xcmpxmodalFontSmall: headerFontSmall == true,
                xcmpxmodalFontMedium: headerFontMedium == true,
                xcmpxmodalFontLarge: headerFontLarge == true,
                xcmpxmodalFontLarger: headerFontLarger == true
              }" style="white-space: nowrap;"
                v-if="$slots.leftHeader6">

                <slot name="leftHeader6"></slot>

                <img v-if="
                  selectedSlotName == 'leftHeader6' &&
                  useAscendingSort &&
                  enableSorting && enableSlotSorting.get('leftHeader6')
                " src="@/assets/images/sort_up.png" class="grdImageSizer" alt="" />
                <img v-if="
                  selectedSlotName == 'leftHeader6' &&
                  !useAscendingSort &&
                  enableSorting && enableSlotSorting.get('leftHeader6')
                " src="@/assets/images/sort_down.png" class="grdImageSizer" alt="" />
                <img v-if="selectedSlotName != 'leftHeader6' && enableSorting && enableSlotSorting.get('leftHeader6')"
                  src="@/assets/images/sort_neither.png" class="grdImageSizer" alt="" />

              </th>
              <!-- --------- Left Slot Header - 7 ---------------- -->
              <th class="grdHeader" @click="handleSlotSort('leftHeader7')" :class="{
                grdSortHeader: (enableSorting == true) && (enableSlotSorting.get('leftHeader7')),
                xcmpxmodalFontSmaller: headerFontSmaller == true,
                xcmpxmodalFontSmall: headerFontSmall == true,
                xcmpxmodalFontMedium: headerFontMedium == true,
                xcmpxmodalFontLarge: headerFontLarge == true,
                xcmpxmodalFontLarger: headerFontLarger == true
              }" style="white-space: nowrap;"
                v-if="$slots.leftHeader7">

                <slot name="leftHeader7"></slot>

                <img v-if="
                  selectedSlotName == 'leftHeader7' &&
                  useAscendingSort &&
                  enableSorting && enableSlotSorting.get('leftHeader7')
                " src="@/assets/images/sort_up.png" class="grdImageSizer" alt="" />
                <img v-if="
                  selectedSlotName == 'leftHeader7' &&
                  !useAscendingSort &&
                  enableSorting && enableSlotSorting.get('leftHeader7')
                " src="@/assets/images/sort_down.png" class="grdImageSizer" alt="" />
                <img v-if="selectedSlotName != 'leftHeader7' && enableSorting && enableSlotSorting.get('leftHeader7')"
                  src="@/assets/images/sort_neither.png" class="grdImageSizer" alt="" />

              </th>
              <!-- --------- Left Slot Header - 8 ---------------- -->
              <th class="grdHeader" @click="handleSlotSort('leftHeader8')" :class="{
                grdSortHeader: (enableSorting == true) && (enableSlotSorting.get('leftHeader8')),
                xcmpxmodalFontSmaller: headerFontSmaller == true,
                xcmpxmodalFontSmall: headerFontSmall == true,
                xcmpxmodalFontMedium: headerFontMedium == true,
                xcmpxmodalFontLarge: headerFontLarge == true,
                xcmpxmodalFontLarger: headerFontLarger == true
              }" style="white-space: nowrap;"
                v-if="$slots.leftHeader8">

                <slot name="leftHeader8"></slot>

                <img v-if="
                  selectedSlotName == 'leftHeader8' &&
                  useAscendingSort &&
                  enableSorting && enableSlotSorting.get('leftHeader8')
                " src="@/assets/images/sort_up.png" class="grdImageSizer" alt="" />
                <img v-if="
                  selectedSlotName == 'leftHeader8' &&
                  !useAscendingSort &&
                  enableSorting && enableSlotSorting.get('leftHeader8')
                " src="@/assets/images/sort_down.png" class="grdImageSizer" alt="" />
                <img v-if="selectedSlotName != 'leftHeader8' && enableSorting && enableSlotSorting.get('leftHeader8')"
                  src="@/assets/images/sort_neither.png" class="grdImageSizer" alt="" />

              </th>
              <!-- --------- Left Slot Header - 9 ---------------- -->
              <th class="grdHeader" @click="handleSlotSort('leftHeader9')" :class="{
                grdSortHeader: (enableSorting == true) && (enableSlotSorting.get('leftHeader9')),
                xcmpxmodalFontSmaller: headerFontSmaller == true,
                xcmpxmodalFontSmall: headerFontSmall == true,
                xcmpxmodalFontMedium: headerFontMedium == true,
                xcmpxmodalFontLarge: headerFontLarge == true,
                xcmpxmodalFontLarger: headerFontLarger == true
              }" style="white-space: nowrap;"
                v-if="$slots.leftHeader9">

                <slot name="leftHeader9"></slot>

                <img v-if="
                  selectedSlotName == 'leftHeader9' &&
                  useAscendingSort &&
                  enableSorting && enableSlotSorting.get('leftHeader9')
                " src="@/assets/images/sort_up.png" class="grdImageSizer" alt="" />
                <img v-if="
                  selectedSlotName == 'leftHeader9' &&
                  !useAscendingSort &&
                  enableSorting && enableSlotSorting.get('leftHeader9')
                " src="@/assets/images/sort_down.png" class="grdImageSizer" alt="" />
                <img v-if="selectedSlotName != 'leftHeader9' && enableSorting && enableSlotSorting.get('leftHeader9')"
                  src="@/assets/images/sort_neither.png" class="grdImageSizer" alt="" />

              </th>

              <!-- --------------------------------------------------- -->
              <!-- --------- Non-Slot Headers - START ---------------- -->
              <!-- --------------------------------------------------- -->
              <th v-for="(item, index) in tblHeaders_DisplayTable" :key="index" @click="handlerHeaderSort(index)"
                class="grdHeader" :class="{
                  grdSortHeader: enableSorting == true,
                  xcmpxmodalFontSmaller: headerFontSmaller == true,
                  xcmpxmodalFontSmall: headerFontSmall == true,
                  xcmpxmodalFontMedium: headerFontMedium == true,
                  xcmpxmodalFontLarge: headerFontLarge == true,
                  xcmpxmodalFontLarger: headerFontLarger == true
                }" style="white-space: nowrap;"
                data-tooltip="tooltip" :title="`${item.hdrHover}`">
                {{ item.hdrText }}
                <img v-if="
                  index == selectedTblHeaderIndex &&
                  useAscendingSort &&
                  enableSorting
                " src="@/assets/images/sort_up.png" class="grdImageSizer" alt="" />
                <img v-if="
                  index == selectedTblHeaderIndex &&
                  !useAscendingSort &&
                  enableSorting
                " src="@/assets/images/sort_down.png" class="grdImageSizer" alt="" />
                <img v-if="index != selectedTblHeaderIndex && enableSorting" src="@/assets/images/sort_neither.png"
                  class="grdImageSizer" alt="" />
              </th>
              <!-- --------------------------------------------------- -->
              <!-- --------- Non-Slot Headers - END ------------------ -->
              <!-- --------------------------------------------------- -->
              
              <!-- ==================================================================== -->
              <!-- ============================ Right Header =========================== -->
              <!-- ==================================================================== -->
              <!-- --------- Right Slot Header - 10 ---------------- -->
              <th class="grdHeader" @click="handleSlotSort('rightHeader10')" :class="{
                grdSortHeader: (enableSorting == true) && (enableSlotSorting.get('rightHeader10')),
                xcmpxmodalFontSmaller: headerFontSmaller == true,
                xcmpxmodalFontSmall: headerFontSmall == true,
                xcmpxmodalFontMedium: headerFontMedium == true,
                xcmpxmodalFontLarge: headerFontLarge == true,
                xcmpxmodalFontLarger: headerFontLarger == true
              }" style="white-space: nowrap;"
                v-if="$slots.rightHeader10">

                <slot name="rightHeader10"></slot>

                <img v-if="
                  selectedSlotName == 'rightHeader10' &&
                  useAscendingSort &&
                  enableSorting && enableSlotSorting.get('rightHeader10')
                " src="@/assets/images/sort_up.png" class="grdImageSizer" alt="" />
                <img v-if="
                  selectedSlotName == 'rightHeader10' &&
                  !useAscendingSort &&
                  enableSorting && enableSlotSorting.get('rightHeader10')
                " src="@/assets/images/sort_down.png" class="grdImageSizer" alt="" />
                <img
                  v-if="selectedSlotName != 'rightHeader10' && enableSorting && enableSlotSorting.get('rightHeader10')"
                  src="@/assets/images/sort_neither.png" class="grdImageSizer" alt="" />

              </th>
              <!-- --------- Right Slot Header - 11 ---------------- -->
              <th class="grdHeader" @click="handleSlotSort('rightHeader11')" :class="{
                grdSortHeader: (enableSorting == true) && (enableSlotSorting.get('rightHeader11')),
                xcmpxmodalFontSmaller: headerFontSmaller == true,
                xcmpxmodalFontSmall: headerFontSmall == true,
                xcmpxmodalFontMedium: headerFontMedium == true,
                xcmpxmodalFontLarge: headerFontLarge == true,
                xcmpxmodalFontLarger: headerFontLarger == true
              }" style="white-space: nowrap;"
                v-if="$slots.rightHeader11">

                <slot name="rightHeader11"></slot>

                <img v-if="
                  selectedSlotName == 'rightHeader11' &&
                  useAscendingSort &&
                  enableSorting && (enableSlotSorting.get('rightHeader11'))
                " src="@/assets/images/sort_up.png" class="grdImageSizer" alt="" />
                <img v-if="
                  selectedSlotName == 'rightHeader11' &&
                  !useAscendingSort &&
                  enableSorting && (enableSlotSorting.get('rightHeader11'))
                " src="@/assets/images/sort_down.png" class="grdImageSizer" alt="" />
                <img
                  v-if="selectedSlotName != 'rightHeader11' && enableSorting && (enableSlotSorting.get('rightHeader11'))"
                  src="@/assets/images/sort_neither.png" class="grdImageSizer" alt="" />
              </th>
              <!-- --------- Right Slot Header - 12 ---------------- -->
              <th class="grdHeader" @click="handleSlotSort('rightHeader12')" :class="{
                grdSortHeader: (enableSorting == true) && (enableSlotSorting.get('rightHeader12')),
                xcmpxmodalFontSmaller: headerFontSmaller == true,
                xcmpxmodalFontSmall: headerFontSmall == true,
                xcmpxmodalFontMedium: headerFontMedium == true,
                xcmpxmodalFontLarge: headerFontLarge == true,
                xcmpxmodalFontLarger: headerFontLarger == true
              }" style="white-space: nowrap;"
                v-if="$slots.rightHeader12">

                <slot name="rightHeader12"></slot>

                <img v-if="
                  selectedSlotName == 'rightHeader12' &&
                  useAscendingSort &&
                  enableSorting && (enableSlotSorting.get('rightHeader12'))
                " src="@/assets/images/sort_up.png" class="grdImageSizer" alt="" />
                <img v-if="
                  selectedSlotName == 'rightHeader12' &&
                  !useAscendingSort &&
                  enableSorting && (enableSlotSorting.get('rightHeader12'))
                " src="@/assets/images/sort_down.png" class="grdImageSizer" alt="" />
                <img
                  v-if="selectedSlotName != 'rightHeader12' && enableSorting && (enableSlotSorting.get('rightHeader12'))"
                  src="@/assets/images/sort_neither.png" class="grdImageSizer" alt="" />
              </th>
              <!-- --------- Right Slot Header - 13 ---------------- -->
              <th class="grdHeader" @click="handleSlotSort('rightHeader13')" :class="{
                grdSortHeader: (enableSorting == true) && (enableSlotSorting.get('rightHeader13')),
                xcmpxmodalFontSmaller: headerFontSmaller == true,
                xcmpxmodalFontSmall: headerFontSmall == true,
                xcmpxmodalFontMedium: headerFontMedium == true,
                xcmpxmodalFontLarge: headerFontLarge == true,
                xcmpxmodalFontLarger: headerFontLarger == true
              }" style="white-space: nowrap;"
                v-if="$slots.rightHeader13">

                <slot name="rightHeader13"></slot>

                <img v-if="
                  selectedSlotName == 'rightHeader13' &&
                  useAscendingSort &&
                  enableSorting && (enableSlotSorting.get('rightHeader13'))
                " src="@/assets/images/sort_up.png" class="grdImageSizer" alt="" />
                <img v-if="
                  selectedSlotName == 'rightHeader13' &&
                  !useAscendingSort &&
                  enableSorting && (enableSlotSorting.get('rightHeader13'))
                " src="@/assets/images/sort_down.png" class="grdImageSizer" alt="" />
                <img
                  v-if="selectedSlotName != 'rightHeader13' && enableSorting && (enableSlotSorting.get('rightHeader13'))"
                  src="@/assets/images/sort_neither.png" class="grdImageSizer" alt="" />
              </th>
              <!-- --------- Right Slot Header - 14 ---------------- -->
              <th class="grdHeader" @click="handleSlotSort('rightHeader14')" :class="{
                grdSortHeader: (enableSorting == true) && (enableSlotSorting.get('rightHeader14')),
                xcmpxmodalFontSmaller: headerFontSmaller == true,
                xcmpxmodalFontSmall: headerFontSmall == true,
                xcmpxmodalFontMedium: headerFontMedium == true,
                xcmpxmodalFontLarge: headerFontLarge == true,
                xcmpxmodalFontLarger: headerFontLarger == true
              }" style="white-space: nowrap;"
                v-if="$slots.rightHeader14">

                <slot name="rightHeader14"></slot>

                <img v-if="
                  selectedSlotName == 'rightHeader14' &&
                  useAscendingSort &&
                  enableSorting && (enableSlotSorting.get('rightHeader14'))
                " src="@/assets/images/sort_up.png" class="grdImageSizer" alt="" />
                <img v-if="
                  selectedSlotName == 'rightHeader14' &&
                  !useAscendingSort &&
                  enableSorting && (enableSlotSorting.get('rightHeader14'))
                " src="@/assets/images/sort_down.png" class="grdImageSizer" alt="" />
                <img
                  v-if="selectedSlotName != 'rightHeader14' && enableSorting && (enableSlotSorting.get('rightHeader14'))"
                  src="@/assets/images/sort_neither.png" class="grdImageSizer" alt="" />
              </th>
              <!-- --------- Right Slot Header - 15 ---------------- -->
              <th class="grdHeader" @click="handleSlotSort('rightHeader15')" :class="{
                grdSortHeader: (enableSorting == true) && (enableSlotSorting.get('rightHeader15')),
                xcmpxmodalFontSmaller: headerFontSmaller == true,
                xcmpxmodalFontSmall: headerFontSmall == true,
                xcmpxmodalFontMedium: headerFontMedium == true,
                xcmpxmodalFontLarge: headerFontLarge == true,
                xcmpxmodalFontLarger: headerFontLarger == true
              }" style="white-space: nowrap;"
                v-if="$slots.rightHeader15">

                <slot name="rightHeader15"></slot>

                <img v-if="
                  selectedSlotName == 'rightHeader15' &&
                  useAscendingSort &&
                  enableSorting && (enableSlotSorting.get('rightHeader15'))
                " src="@/assets/images/sort_up.png" class="grdImageSizer" alt="" />
                <img v-if="
                  selectedSlotName == 'rightHeader15' &&
                  !useAscendingSort &&
                  enableSorting && (enableSlotSorting.get('rightHeader15'))
                " src="@/assets/images/sort_down.png" class="grdImageSizer" alt="" />
                <img
                  v-if="selectedSlotName != 'rightHeader15' && enableSorting && (enableSlotSorting.get('rightHeader15'))"
                  src="@/assets/images/sort_neither.png" class="grdImageSizer" alt="" />
              </th>
              <!-- --------- Right Slot Header - 16 ---------------- -->
              <th class="grdHeader" @click="handleSlotSort('rightHeader16')" :class="{
                grdSortHeader: (enableSorting == true) && (enableSlotSorting.get('rightHeader16')),
                xcmpxmodalFontSmaller: headerFontSmaller == true,
                xcmpxmodalFontSmall: headerFontSmall == true,
                xcmpxmodalFontMedium: headerFontMedium == true,
                xcmpxmodalFontLarge: headerFontLarge == true,
                xcmpxmodalFontLarger: headerFontLarger == true
              }" style="white-space: nowrap;"
                v-if="$slots.rightHeader16">

                <slot name="rightHeader16"></slot>

                <img v-if="
                  selectedSlotName == 'rightHeader16' &&
                  useAscendingSort &&
                  enableSorting && (enableSlotSorting.get('rightHeader16'))
                " src="@/assets/images/sort_up.png" class="grdImageSizer" alt="" />
                <img v-if="
                  selectedSlotName == 'rightHeader16' &&
                  !useAscendingSort &&
                  enableSorting && (enableSlotSorting.get('rightHeader16'))
                " src="@/assets/images/sort_down.png" class="grdImageSizer" alt="" />
                <img
                  v-if="selectedSlotName != 'rightHeader16' && enableSorting && (enableSlotSorting.get('rightHeader16'))"
                  src="@/assets/images/sort_neither.png" class="grdImageSizer" alt="" />
              </th>
              <!-- --------- Right Slot Header - 17 ---------------- -->
              <th class="grdHeader" @click="handleSlotSort('rightHeader17')" :class="{
                grdSortHeader: (enableSorting == true) && (enableSlotSorting.get('rightHeader17')),
                xcmpxmodalFontSmaller: headerFontSmaller == true,
                xcmpxmodalFontSmall: headerFontSmall == true,
                xcmpxmodalFontMedium: headerFontMedium == true,
                xcmpxmodalFontLarge: headerFontLarge == true,
                xcmpxmodalFontLarger: headerFontLarger == true
              }" style="white-space: nowrap;"
                v-if="$slots.rightHeader17">

                <slot name="rightHeader17"></slot>

                <img v-if="
                  selectedSlotName == 'rightHeader17' &&
                  useAscendingSort &&
                  enableSorting && (enableSlotSorting.get('rightHeader17'))
                " src="@/assets/images/sort_up.png" class="grdImageSizer" alt="" />
                <img v-if="
                  selectedSlotName == 'rightHeader17' &&
                  !useAscendingSort &&
                  enableSorting && (enableSlotSorting.get('rightHeader17'))
                " src="@/assets/images/sort_down.png" class="grdImageSizer" alt="" />
                <img
                  v-if="selectedSlotName != 'rightHeader17' && enableSorting && (enableSlotSorting.get('rightHeader17'))"
                  src="@/assets/images/sort_neither.png" class="grdImageSizer" alt="" />
              </th>
              <!-- --------- Right Slot Header - 18 ---------------- -->
              <th class="grdHeader" @click="handleSlotSort('rightHeader18')" :class="{
                grdSortHeader: (enableSorting == true) && (enableSlotSorting.get('rightHeader18')),
                xcmpxmodalFontSmaller: headerFontSmaller == true,
                xcmpxmodalFontSmall: headerFontSmall == true,
                xcmpxmodalFontMedium: headerFontMedium == true,
                xcmpxmodalFontLarge: headerFontLarge == true,
                xcmpxmodalFontLarger: headerFontLarger == true
              }" style="white-space: nowrap;"
                v-if="$slots.rightHeader18">

                <slot name="rightHeader18"></slot>

                <img v-if="
                  selectedSlotName == 'rightHeader18' &&
                  useAscendingSort &&
                  enableSorting && (enableSlotSorting.get('rightHeader18'))
                " src="@/assets/images/sort_up.png" class="grdImageSizer" alt="" />
                <img v-if="
                  selectedSlotName == 'rightHeader18' &&
                  !useAscendingSort &&
                  enableSorting && (enableSlotSorting.get('rightHeader18'))
                " src="@/assets/images/sort_down.png" class="grdImageSizer" alt="" />
                <img
                  v-if="selectedSlotName != 'rightHeader18' && enableSorting && (enableSlotSorting.get('rightHeader18'))"
                  src="@/assets/images/sort_neither.png" class="grdImageSizer" alt="" />
              </th>
              <!-- --------- Right Slot Header - 19 ---------------- -->
              <th class="grdHeader" @click="handleSlotSort('rightHeader19')" :class="{
                grdSortHeader: (enableSorting == true) && (enableSlotSorting.get('rightHeader19')),
                xcmpxmodalFontSmaller: headerFontSmaller == true,
                xcmpxmodalFontSmall: headerFontSmall == true,
                xcmpxmodalFontMedium: headerFontMedium == true,
                xcmpxmodalFontLarge: headerFontLarge == true,
                xcmpxmodalFontLarger: headerFontLarger == true
              }" style="white-space: nowrap;"
                v-if="$slots.rightHeader19">

                <slot name="rightHeader19"></slot>

                <img v-if="
                  selectedSlotName == 'rightHeader19' &&
                  useAscendingSort &&
                  enableSorting && (enableSlotSorting.get('rightHeader19'))
                " src="@/assets/images/sort_up.png" class="grdImageSizer" alt="" />
                <img v-if="
                  selectedSlotName == 'rightHeader19' &&
                  !useAscendingSort &&
                  enableSorting && (enableSlotSorting.get('rightHeader19'))
                " src="@/assets/images/sort_down.png" class="grdImageSizer" alt="" />
                <img
                  v-if="selectedSlotName != 'rightHeader19' && enableSorting && (enableSlotSorting.get('rightHeader19'))"
                  src="@/assets/images/sort_neither.png" class="grdImageSizer" alt="" />
              </th>
              <!-- --------- Right Slot Header - END ---------------- -->

            </tr>
          </thead>

          <!-- ------------------------------- -->
          <!-- --------- Body ---------------- -->
          <!-- -------------------------------- -->

          <tbody>
            <tr v-show="noRecordsFound">
              <td :colspan="numberOfFields" class="grdTdCenter">
                No records found
              </td>
            </tr>

            <tr v-for="(item, index) in displayGrid" :item="item" :index="index" :key="index" :id="index"
              value="{{ item[activeGridKeys_DisplayTable[0]] }}">

              <!-- ==================================================================== -->
              <!-- ============================ Left Data ============================= -->
              <!-- ==================================================================== -->
              <!-- --------- Left Data Slot - 0 ---------------- -->
              <td v-if="$slots.leftData0">
                <div class="grdTdLeft">
                  <slot name="leftData0" :itemArg="item" :indexArg="index"></slot>
                </div>
              </td>
              <!-- --------- Left Data Slot - 1 ---------------- -->
              <td v-if="$slots.leftData1">
                <div class="grdTdLeft">
                  <slot name="leftData1" :itemArg="item" :indexArg="index"></slot>
                </div>
              </td>
              <!-- --------- Left Data Slot - 2 ---------------- -->
              <td v-if="$slots.leftData2">
                <div class="grdTdLeft">
                  <slot name="leftData2" :itemArg="item" :indexArg="index"></slot>
                </div>
              </td>
              <!-- --------- Left Data Slot - 3 ---------------- -->
              <td v-if="$slots.leftData3">
                <div class="grdTdLeft">
                  <slot name="leftData3" :itemArg="item" :indexArg="index"></slot>
                </div>
              </td>
              <!-- --------- Left Data Slot - 4 ---------------- -->
              <td v-if="$slots.leftData4">
                <div class="grdTdLeft">
                  <slot name="leftData4" :itemArg="item" :indexArg="index"></slot>
                </div>
              </td>
              <!-- --------- Left Data Slot - 5 ---------------- -->
              <td v-if="$slots.leftData5">
                <div class="grdTdLeft">
                  <slot name="leftData5" :itemArg="item" :indexArg="index"></slot>
                </div>
              </td>
              <!-- --------- Left Data Slot - 6 ---------------- -->
              <td v-if="$slots.leftData6">
                <div class="grdTdLeft">
                  <slot name="leftData6" :itemArg="item" :indexArg="index"></slot>
                </div>
              </td>
              <!-- --------- Left Data Slot - 7 ---------------- -->
              <td v-if="$slots.leftData7">
                <div class="grdTdLeft">
                  <slot name="leftData7" :itemArg="item" :indexArg="index"></slot>
                </div>
              </td>
              <!-- --------- Left Data Slot - 8 ---------------- -->
              <td v-if="$slots.leftData8">
                <div class="grdTdLeft">
                  <slot name="leftData8" :itemArg="item" :indexArg="index"></slot>
                </div>
              </td>
              <!-- --------- Left Data Slot - 9 ---------------- -->
              <td v-if="$slots.leftData9">
                <div class="grdTdLeft">
                  <slot name="leftData9" :itemArg="item" :indexArg="index"></slot>
                </div>
              </td>

              <!-- ------------------------------------------------- -->
              <!-- --------- Main Grid Data - START ---------------- -->
              <!-- ------------------------------------------------- -->

              <td v-for="(tdItem, tdIndex) in activeGridKeys_DisplayTable" :key="tdIndex" class="grdTdLeft" :class="{
                xcmpxmodalFontSmaller: dataFontSmaller == true,
                xcmpxmodalFontSmall: dataFontSmall == true,
                xcmpxmodalFontMedium: dataFontMedium == true,
                xcmpxmodalFontLarge: dataFontLarge == true,
                xcmpxmodalFontLarger: dataFontLarger == true
              }">

                <!-- ====================================================================== -->
                <!-- ============================ Center Data ============================= -->
                <!-- ====================================================================== -->
                <!-- -------------------------- center 0 -------------------------- -->
                <div class="grdTdLeft" v-if="$slots.centerGrid0 && (tdItem == centerGridSlots.get('centerGrid0'))">
                  <slot name="centerGrid0" :itemArg="item" :indexArg="index"></slot>
                </div>
                <!-- -------------------------- center 1 -------------------------- -->
                <div class="grdTdLeft" v-else-if="$slots.centerGrid1 && (tdItem == centerGridSlots.get('centerGrid1'))">
                  <slot name="centerGrid1" :itemArg="item" :indexArg="index"></slot>
                </div>
                <!-- -------------------------- center 2 -------------------------- -->
                <div class="grdTdLeft" v-else-if="$slots.centerGrid2 && (tdItem == centerGridSlots.get('centerGrid2'))">
                  <slot name="centerGrid2" :itemArg="item" :indexArg="index"></slot>
                </div>
                <!-- -------------------------- center 3 -------------------------- -->
                <div class="grdTdLeft" v-else-if="$slots.centerGrid3 && (tdItem == centerGridSlots.get('centerGrid3'))">
                  <slot name="centerGrid3" :itemArg="item" :indexArg="index"></slot>
                </div>
                <!-- -------------------------- center 4 -------------------------- -->
                <div class="grdTdLeft" v-else-if="$slots.centerGrid4 && (tdItem == centerGridSlots.get('centerGrid4'))">
                  <slot name="centerGrid4" :itemArg="item" :indexArg="index"></slot>
                </div>
                <!-- -------------------------- center 5 -------------------------- -->
                <div class="grdTdLeft" v-else-if="$slots.centerGrid5 && (tdItem == centerGridSlots.get('centerGrid5'))">
                  <slot name="centerGrid5" :itemArg="item" :indexArg="index"></slot>
                </div>
                <!-- -------------------------- center 6 -------------------------- -->
                <div class="grdTdLeft" v-else-if="$slots.centerGrid6 && (tdItem == centerGridSlots.get('centerGrid6'))">
                  <slot name="centerGrid6" :itemArg="item" :indexArg="index"></slot>
                </div>
                <!-- -------------------------- center 7 -------------------------- -->
                <div class="grdTdLeft" v-else-if="$slots.centerGrid7 && (tdItem == centerGridSlots.get('centerGrid7'))">
                  <slot name="centerGrid7" :itemArg="item" :indexArg="index"></slot>
                </div>
                <!-- -------------------------- center 8 -------------------------- -->
                <div class="grdTdLeft" v-else-if="$slots.centerGrid8 && (tdItem == centerGridSlots.get('centerGrid8'))">
                  <slot name="centerGrid8" :itemArg="item" :indexArg="index"></slot>
                </div>
                <!-- -------------------------- center 9 -------------------------- -->
                <div class="grdTdLeft" v-else-if="$slots.centerGrid9 && (tdItem == centerGridSlots.get('centerGrid9'))">
                  <slot name="centerGrid9" :itemArg="item" :indexArg="index"></slot>
                </div>
                <!-- -------------------------- center 10 -------------------------- -->
                <div class="grdTdLeft" v-else-if="$slots.centerGrid10 && (tdItem == centerGridSlots.get('centerGrid10'))">
                  <slot name="centerGrid10" :itemArg="item" :indexArg="index"></slot>
                </div>
                <!-- -------------------------- center 11 -------------------------- -->
                <div class="grdTdLeft" v-else-if="$slots.centerGrid11 && (tdItem == centerGridSlots.get('centerGrid11'))">
                  <slot name="centerGrid11" :itemArg="item" :indexArg="index"></slot>
                </div>
                <!-- -------------------------- center 12 -------------------------- -->
                <div class="grdTdLeft" v-else-if="$slots.centerGrid12 && (tdItem == centerGridSlots.get('centerGrid12'))">
                  <slot name="centerGrid12" :itemArg="item" :indexArg="index"></slot>
                </div>
                <!-- -------------------------- center 13 -------------------------- -->
                <div class="grdTdLeft" v-else-if="$slots.centerGrid13 && (tdItem == centerGridSlots.get('centerGrid13'))">
                  <slot name="centerGrid13" :itemArg="item" :indexArg="index"></slot>
                </div>
                <!-- -------------------------- center 14 -------------------------- -->
                <div class="grdTdLeft" v-else-if="$slots.centerGrid14 && (tdItem == centerGridSlots.get('centerGrid14'))">
                  <slot name="centerGrid14" :itemArg="item" :indexArg="index"></slot>
                </div>
                <!-- -------------------------- center 15 -------------------------- -->
                <div class="grdTdLeft" v-else-if="$slots.centerGrid15 && (tdItem == centerGridSlots.get('centerGrid15'))">
                  <slot name="centerGrid15" :itemArg="item" :indexArg="index"></slot>
                </div>

                <span v-else v-html="item[tdItem]"></span>

              </td>

              <!-- ------------------------------------------------- -->
              <!-- --------- Main Grid Data - END ------------------ -->
              <!-- ------------------------------------------------- -->

              <!-- ====================================================================== -->
              <!-- ============================ Right Data ============================== -->
              <!-- ====================================================================== -->
              <!-- --------- Right Data Slot - 10 ---------------- -->
              <td v-if="$slots.rightData10">
                <div class="grdTdLeft">
                  <slot name="rightData10" :itemArg="item" :indexArg="index"></slot>
                </div>
              </td>
              <!-- --------- Right Data Slot - 11 ---------------- -->
              <td v-if="$slots.rightData11">
                <div class="grdTdLeft">
                  <slot name="rightData11" :itemArg="item" :indexArg="index"></slot>
                </div>
              </td>
              <!-- --------- Right Data Slot - 12 ---------------- -->
              <td v-if="$slots.rightData12">
                <div class="grdTdLeft">
                  <slot name="rightData12" :itemArg="item" :indexArg="index"></slot>
                </div>
              </td>
              <!-- --------- Right Data Slot - 13 ---------------- -->
              <td v-if="$slots.rightData13">
                <div class="grdTdLeft">
                  <slot name="rightData13" :itemArg="item" :indexArg="index"></slot>
                </div>
              </td>
              <!-- --------- Right Data Slot - 14 ---------------- -->
              <td v-if="$slots.rightData14">
                <div class="grdTdLeft">
                  <slot name="rightData14" :itemArg="item" :indexArg="index"></slot>
                </div>
              </td>
              <!-- --------- Right Data Slot - 15 ---------------- -->
              <td v-if="$slots.rightData15">
                <div class="grdTdLeft">
                  <slot name="rightData15" :itemArg="item" :indexArg="index"></slot>
                </div>
              </td>
              <!-- --------- Right Data Slot - 16 ---------------- -->
              <td v-if="$slots.rightData16">
                <div class="grdTdLeft">
                  <slot name="rightData16" :itemArg="item" :indexArg="index"></slot>
                </div>
              </td>
              <!-- --------- Right Data Slot - 17 ---------------- -->
              <td v-if="$slots.rightData17">
                <div class="grdTdLeft">
                  <slot name="rightData17" :itemArg="item" :indexArg="index"></slot>
                </div>
              </td>
              <!-- --------- Right Data Slot - 18 ---------------- -->
              <td v-if="$slots.rightData18">
                <div class="grdTdLeft">
                  <slot name="rightData18" :itemArg="item" :indexArg="index"></slot>
                </div>
              </td>
              <!-- --------- Right Data Slot - 19 ---------------- -->
              <td v-if="$slots.rightData19">
                <div class="grdTdLeft">
                  <slot name="rightData19" :itemArg="item" :indexArg="index"></slot>
                </div>
              </td>
              <!-- --------- Right Data Slot - END ---------------- -->

            </tr>
          </tbody>
        </table>
      </div>

      <!-- ########################################## -->
      <!-- ----------------- PAGING ----------------- -->
      <!-- ########################################## -->

      <!-- ------------- records info --------------------- -->

      <div class="condensedContainerInfo" v-if="(enablePaging == false) && enableRecordsInfoDisplay && noRecordsFound == false">
        <div style="font-weight: bold;  white-space: normal;">AAA-{{ recordsInfo }}</div>
      </div>

      <div v-if="enablePaging && noRecordsFound == false" class="pageInfoMargines">

        <div :class="{
            condensedContainerPagingB: (enableRecordsInfoDisplay == false),
            condensedContainerPagingA: (enableRecordsInfoDisplay == true)}">

           <!-- ++++ paging IS enabled ++++ -->
          <!-- 1111111111111111111111 -->
          <div  style="text-align: left; align-items: left; font-weight: bold; white-space: normal;" 
                v-if="enableRecordsInfoDisplay  && noRecordsFound == false">
            <div style="margin-top: 5px;">{{ recordsInfo }}</div>
          </div>
          <!-- 2222222222222222222222 -->

          <div class="pagingOnlyDiv alignAllRight">

              <!-- ++++ Page Counts ++++ -->
              <!-- aaaaaaaaaaaaaaaaaaaaaaaa -->
              <div>
                  <div class="pgeMarginRightLarge" style="margin-top: 5px; white-space: normal;">
                      {{ firstPageInCurrentGroup }} to {{ lastPageInCurrentGroup }} of {{ totalNumberPages }} pages
                  </div>
              </div>
              <!-- bbbbbbbbbbbbbbbbbbbbb -->

              <div>
                  <!-- ----------------------------------------------------------------------------- -->
                  <!-- ----------------------------- Page Number Controls -------------------------- -->
                  <!-- ----------------------------------------------------------------------------- -->
                  <div class="pgeDivBox pgeNumbersRow">

                      <!-- --------- First Numbers -------------- -->
                      <div id="xcmpxBtnFirst" @click="btnClickFirst" class="pgeDivBoxBrdRight pgeDivboxPadding" :class="{
                  pgeBtnPaggingBase: inFirstGroup == false,}">
                          First
                      </div>

                      <div id="xcmpxEllipsisLeft" @click="btnClickLeftEllipsis" class="pgeDivBoxBrdRight pgeDivboxPadding" :class="{
                  pgeBtnPaggingBase: inFirstGroup == false,}">
                          &#8230;
                      </div>

                      <!-- --------- Dynamic Page Numbers -------------- -->
                      <div v-for="number in pageCtrlArray" :key="number" :id="setButtonID(number)"
                           @click="btnClickHandler(number)" class="pgeDivboxPadding pgeBtnPaggingBase" :class="{
                    'pgeDivBoxBrdRight pgeDivboxPadding':
                      number != totalNumberPages,
                    pgeBtnPaggingSelected: number == selectedBtnNumber,}">
                          {{ number }}
                      </div>

                      <!-- --------- Last Numbers -------------- -->
                      <div class="pgeDivBoxBrdRight pgeDivBoxBrdLeft pgeDivboxPadding" @click="btnClickRightEllipsis" :class="{
                  pgeBtnPaggingBase: inLastGroup == false,}"
                           id="xcmpxEllipsisRight">
                          &#8230;
                      </div>

                      <div id="xcmpxBtnLast" @click="btnClickLast" class="pgeDivboxPadding" :class="{
                  pgeBtnPaggingBase: inLastGroup == false,}">
                          Last
                      </div>
                  </div>

              </div>

              <!-- cccccccccccccccccccc ROWS PER PAGE -->
              <div v-if="false" class="pgeJustify-Content-Left">
                  <div class="pgeMarginRowsPerPage pgeJustify-Content-Right">
                      Show
                  </div>
                  <div>
                      <select class="form-select form-select-sm pgeSelectSizing pgeMarginZero pgeDivboxPadding" id="xcmpxRowsPerPage_ID" aria-label="Select the number of records to show"
                              @change="rowsPerPageOnchange" v-model="rppSelected">
                          <option v-for="item in rppArray" :value="item.records" :key="item.display">
                              {{ item.display }}
                          </option>
                      </select>
                      <span style="margin-left: 10px;">{{ rowsPerPageText }}</span>
                  </div>
              </div>
              <!-- cccccccccccccccccccc END -->

          </div>

        </div>

      </div>


   

      <!-- ########################################## -->
      <!-- ----------------- SETTINGS --------------- -->
      <!-- ########################################## -->

      <!-- ----------------------------------------------------------------------------- -->
      <!-- --------------------------- Settings MODAL START ---------------------------- -->
      <!-- ----------------------------------------------------------------------------- -->

      <div v-if="showSettingsModalWindow" id="xcmpgridx-CmpGrid-Settings-ID" class="xcmpxmodal-container-main">
        <div class="xcmpxmodal-container-content">

          <!-- ---------------------------------------------------------------- -->
          <!-- --------------------------- HEADER ----------------------------- -->
          <!-- ---------------------------------------------------------------- -->

          <div class="xcmpxmodal-header">{{ modalTitle }}</div>

          <hr class="xcmpxmodal-hr-top" />

          <!-- ---------------------------------------------------------------- -->
          <!-- --------------------------- FORM ------------------------------- -->
          <!-- ---------------------------------------------------------------- -->

          <div class="row">

            <div class="col" style="border-right: 1px solid #b3b3b3;">
              <div><strong>Select the columns to display:</strong></div>
              <div class="xcmpxmodal-container-form" v-for="(item, index) in tblHeaders_All" :key="index">

                <div class="xcmpxmodal-content-justify-right xcmpxmodal-control-labels">
                  {{ item.hdrText }}
                </div>
                <div class="xcmpxmodal-content-justify-left">
                  <input @change="handleRadioCheckboxClick" type="checkbox" :id="`${'ckbx' + item.rawKey + 'ID'}`"
                    :name="`${item.hdrText}`" />
                </div>
              </div>
            </div>

            <div class="col">
              <div><strong>Select Desired Controls:</strong></div>
              <div class="xcmpxmodal-container-form">

                <!-- ----------- searching -------------- -->
                <div class="xcmpxmodal-content-justify-right xcmpxmodal-control-labels">
                  Searching
                </div>
                <div class="xcmpxmodal-content-justify-left">
                  <input @change="handleRadioCheckboxClick" type="checkbox" id="xcmpgridxSettingsSearchingID"
                    :name="Settings" />
                </div>

                <!-- ----------- paging -------------- -->
                <div class="xcmpxmodal-content-justify-right xcmpxmodal-control-labels">
                  Paging
                </div>
                <div class="xcmpxmodal-content-justify-left">
                  <input @change="handleRadioCheckboxClick" type="checkbox" id="xcmpgridxSettingsPagingID"
                    :name="Settings" />
                </div>

                <!-- ----------- sorting -------------- -->
                <div class="xcmpxmodal-content-justify-right xcmpxmodal-control-labels">
                  Sorting
                </div>
                <div class="xcmpxmodal-content-justify-left">
                  <input @change="handleRadioCheckboxClick" type="checkbox" id="xcmpgridxSettingsSortingID"
                    :name="Settings" />
                </div>
              </div>

            </div>

          </div>

          <hr class="xcmpxmodal-hr-top" />

          <div class="row">
            <div class="col">
              <div><strong>Set Fonts:</strong></div>
              <div class="xcmpxmodal-container-form-font">

                <!-- ----------- searching -------------- -->
                <div class="xcmpxmodal-content-justify-right xcmpxmodal-control-labels">
                  Header:
                </div>
                <div class="xcmpxmodal-content-justify-left">
                  <input @change="handleRadioCheckboxClick" class="marginLeftFontRadio" type="radio"
                    id="xcmpgrHeaderSmaller" name="headerFont" />
                  <span class="marginLeftFontLabel xcmpxmodalFontSmaller">smaller</span>
                  <input @change="handleRadioCheckboxClick" class="marginLeftFontRadio" type="radio"
                    id="xcmpgrHeaderSmall" name="headerFont" />
                  <span class="marginLeftFontLabel xcmpxmodalFontSmall">small</span>
                  <input @change="handleRadioCheckboxClick" class="marginLeftFontRadio" type="radio"
                    id="xcmpgrHeaderMedium" name="headerFont" />
                  <span class="marginLeftFontLabel xcmpxmodalFontMedium">medium</span>
                  <input @change="handleRadioCheckboxClick" class="marginLeftFontRadio" type="radio"
                    id="xcmpgrHeaderLarge" name="headerFont" />
                  <span class="marginLeftFontLabel xcmpxmodalFontLarge">large</span>
                  <input @change="handleRadioCheckboxClick" class="marginLeftFontRadio" type="radio"
                    id="xcmpgrHeaderLarger" name="headerFont" />
                  <span class="marginLeftFontLabel xcmpxmodalFontLarger">larger</span>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="xcmpxmodal-container-form-font">

                <!-- ----------- searching -------------- -->
                <div class="xcmpxmodal-content-justify-right xcmpxmodal-control-labels">
                  Data:
                </div>
                <div class="xcmpxmodal-content-justify-left">
                  <input @change="handleRadioCheckboxClick" class="marginLeftFontRadio" type="radio"
                    id="xcmpgrDataSmaller" name="dataFont" />
                  <span class="marginLeftFontLabel xcmpxmodalFontSmaller">smaller</span>
                  <input @change="handleRadioCheckboxClick" class="marginLeftFontRadio" type="radio" id="xcmpgrDataSmall"
                    name="dataFont" />
                  <span class="marginLeftFontLabel xcmpxmodalFontSmall">small</span>
                  <input @change="handleRadioCheckboxClick" class="marginLeftFontRadio" type="radio" id="xcmpgrDataMedium"
                    name="dataFont" />
                  <span class="marginLeftFontLabel xcmpxmodalFontMedium">medium</span>
                  <input @change="handleRadioCheckboxClick" class="marginLeftFontRadio" type="radio" id="xcmpgrDataLarge"
                    name="dataFont" />
                  <span class="marginLeftFontLabel xcmpxmodalFontLarge">large</span>
                  <input @change="handleRadioCheckboxClick" class="marginLeftFontRadio" type="radio" id="xcmpgrDataLarger"
                    name="dataFont" />
                  <span class="marginLeftFontLabel xcmpxmodalFontLarger">larger</span>
                </div>
              </div>
            </div>
          </div>

          <hr class="xcmpxmodal-hr-top" />

          <!-- ---------------------------------------------------------------- -->
          <!-- --------------------------- Footer ----------------------------- -->
          <!-- ---------------------------------------------------------------- -->

          <div class="xcmpxmodal-footer">
            <button type="button" @click="handleCancelButtonClick" data-tooltip="tooltip"
              title="Close this window without making any changes."
              class="xcmpxmodal-cancelButton xcmpxmodal-button-Radius">
              Cancel
            </button>
            <button id="xcmpgridx-submit-btn-id" type="button" @click="handleSubmitButtonClick" data-tooltip="tooltip"
              title="Update the control to selected settings."
              class="xcmpxmodal-yesSubmitButton xcmpxmodal-button-Radius">
              Submit
            </button>
            <button id="xcmpgridx-reset-btn-id" type="button" @click="handleResetSettings" data-tooltip="tooltip"
              title="Reset to original settings." class="xcmpxmodal-yesSubmitButton xcmpxmodal-button-Radius">
              Reset
            </button>
          </div>
        </div>
      </div>

      <!-- ----------------------------------------------------------------------------- -->
      <!-- --------------------------- Settings MODAL END ------------------------------ -->
      <!-- ----------------------------------------------------------------------------- -->

    </div>
  </div>
</template>

<script>
import { toRaw } from "@vue/reactivity";

 export default {
  props: {
    EnableSearching: { type: Boolean, defautl: true },
    EnableSorting: { type: Boolean, defautl: true },
    EnablePaging: { type: Boolean, defautl: true },
  },
  data() {
    return {

      // ---------------------------------------------
      // ------------------- DEBUG -------------------
      // ---------------------------------------------

      enableFunctionTracing: false,
      enableDataLog: false,

      // ---------------------------------------------
      // ------------------- SLOTS -------------------
      // ---------------------------------------------

      selectedSlotName: -1,

      //Booleans indicating whether or not sorting is enabled for a slot.
      //This map is indexed by slot name. See initializeLeftRightSlots().
      enableSlotSorting: new Map(),

      //Fields validated against the raw grid keys for input grid data.
      //This map is indexed by slot name. See initializeLeftRightSlots().
      validatedSortFields: new Map(),

      //This is used to capture the user specified slot/field-name pairs. The map is
      //then used to control the rendering of slot controls. See initializeCenterGridSlots().
      centerGridSlots: new Map(),

      // ---------------------------------------------
      // ------------------- SEARCH ------------------
      // ---------------------------------------------

      enableSearching: this.EnableSearching, // This is the default value.
      numberOfFields: this.NumberOfFields, // Default value. This needs to be updated.
      searchString: null,
      rowsPerPageText: this.RowsPerPageText,
      searchText: this.SearchText,

      // ---------------------------------------------
      // ------------------- GRID ------------------
      // ---------------------------------------------

      rawGrid: new Array(),
      workGrid: new Array(),
      displayGrid: new Array(),

      noRecordsFound: false,

      // -------------- Header Arrays

      rawGridKeys: new Array(),
      activeGridKeys: new Array(), //This determines which columns of data are displayed.

      //This is an array of javascript objects. Each object holds the HEADER TEXT and HOVER TEXT.
      // {
      //    hdrText: "Role",
      //    hdrHover: "Role Name hover text"
      // }
      tblHeaders_All: new Array(), //This includes all table headers, even those not marked as displayed by default.

      orderRawNames_specified: null, //true ==>  HeaderArrays.rawNames specified
      orderedCustomNames_specified: null, //true ==>  HeaderArrays.displayNames specified
      orderedHoverText_specified: null, //true ==>  HeaderArrays.hoverText specified

      //This is a javascript object which contains 3 array fields.
      //    {
      //      rawNames: null,
      //      displayNames: null,
      //      hoverText: null,
      // };
      headerArrays: null,
      headerArraysIsWellDefined: false,

      // ---------------------------------------------
      // ------------------- PAGING ------------------
      // ---------------------------------------------
      enablePaging: false, // This is the default value.

      pageCtrlArray: new Array(),
      rppArray: [{ display: '5', records: 5 }, { display: '10', records: 10 }, { display: '15', records: 15 }, { display: 'All', records: 500 }],
      rppDefault: [{ display: '5', records: 5 }, { display: '10', records: 10 }, { display: '15', records: 15 }, { display: 'All', records: 500 }],
      rppSelected: 5,

      firstPageInCurrentGroup: null,
      lastPageInCurrentGroup: null,
      inFirstGroup: true,
      inLastGroup: true,

      selectedBtnNumber: 1,

      // Control Settings
      maxRowsPerPage: 10, //Default value.
      maxPPC: 6, //We need a value for this. Here we define a default value. The user can override this.
      showFirstLast: true,

      // Computed properties.
      totalNumberPages: null,

      currentPageGroup: null,
      pageGroupCount: null,

      // ---------------------------------------------
      // ------------------- SORTING ------------------
      // ---------------------------------------------
      enableSorting: false, // This is the default value.
      columnTypeArray: new Array(), //For each column, this holds the column header string and datatype of the header.

      useAscendingSort: true, // This is the default value.
      selectedTblHeaderIndex: null,
      fieldSortedOn: null,

      // ---------------------------------------------
      // ------------------- SETTINGS ----------------
      // ---------------------------------------------

      //-------------
      //-------- font
      //-------------

      headerFontSmaller: false,
      headerFontSmall: false,
      headerFontMedium: false,
      headerFontLarge: false,
      headerFontLarger: false,

      dataFontSmaller: false,
      dataFontSmall: false,
      dataFontMedium: false,
      dataFontLarge: false,
      dataFontLarger: false,

      settingsFontArray: null,

      //--------------
      //-------- other
      //--------------

      //This attribute is used to display (s).
      //settings processing.
      settingsActive: false,

      //These two arrays are only used to control what is displayed
      //to the user. Their values are obtained from the non-settings
      //arrays by the same name, minus the word Settings at the end of the names.
      //
      activeGridKeys_DisplayTable: new Array(), //This determines which columns of data are displayed (settings).
      tblHeaders_DisplayTable: new Array(), //This determines what table headers are displayed (settings).

      settingsControlArray: new Array(), //This array holds all controls used in the settings modal.      

      //This is used in a v-if statement to ensure that the modal window
      //can be completely eliminated from pages in which this
      //control is rendered.
      showSettingsModalWindow: false,

      showSettingsIcon: false,
      modalTitle: 'Grid Settings',

      enableRecordsInfoDisplay: false,

    };
   },

  created() {
    if (this.$data.enableFunctionTracing) {
      console.log("**** created: ****");
    }
    this.createdFnc();
  },

  props: {
    GridData: { type: Object, require: true }, //This is the raw data and is never modified.

    RowsPerPageText: { type: String, require: false }, //Label appearing after rows per page dropdown.
    SearchText: { type: String, require: false }, //Label appearing after rows per page dropdown.

    //The array is a list of JSON objects. Examples are shown below:
    // [
    //   { defaultShow: false, rawName: 'agency_ID', displayName: 'Agency ID', hoverText: 'Agency database primary key' },
    //     ...
    //   { defaultShow: true, rawName: 'active', displayName: 'active', hoverText: 'Agency Active Status' }
    // ]
    HeaderArrays: { type: Object, require: false },

    //The array is a list of JSON objects. Examples are shown below:
    // [
    //   { slot: 'leftHeader0',   enableSorting: true, field: 'emailVerified'},
    //   { slot: 'leftHeader9',   enableSorting: true, field: 'active'},
    //     ...
    //   { slot: 'rightHeader19', enableSorting: true, field: '__not_specified__'}
    // ]
    //If this control is passed bad data such as incorrect slot names or
    //non-existent field names, that information is simply ignored. No
    //errors will result.
    //
    //The purpose of this map is to enable or disable sorting on slots.
    //When enabled, it tells the slot what field to sort on.
    LeftRightSlots: { type: Object, require: false },


    //The array is a list of JSON objects. Examples are shown below:
    // [
    //   {slot: 'centerGrid0',  field: 'zipCode'},
    //   {slot: 'centerGrid1',  field: 'active'},
    //     ...
    //   {slot: 'centerGrid15', field: 'acronym'}
    // ]
    //If this control is passed bad data such as incorrect slot names or
    //non-existent field names, that information is simply ignored. No
    //errors will result.
    //
    //The purpose of this map is to connect slot names to field names.
    //That way we know which slot uses which field.
    CenterGridSlots: { type: Object, require: false },

    EnableSearching: { type: Boolean, require: false },
    EnablePaging: { type: Boolean, require: false },
    EnableSorting: { type: Boolean, require: false },

    // -------------- paging
    RowsPerPageArray: { type: Array, require: false },
    MaximumPagesInControl: { type: Number, require: false },

    // -------------- settings
    EnableSettings: { type: Boolean, require: false },

    // --------------- Show Record Information
    EnableRecordsInfoDisplay: { type: Boolean, require: false },
  },
  computed: {
    recordsInfo() {
      // console.log('---@@@ @@@---');
      // console.log('workGrid.length = ', this.$data.workGrid.length);
      // console.log('displayGrid.length = ', this.$data.displayGrid.length);
      // console.log('rawGrid.length = ', this.$data.rawGrid.length);

      let rpp = this.$data.rppSelected;
      let n = this.$data.selectedBtnNumber;

      let total = this.$data.workGrid.length;

      let firstRecord = (n - 1) * rpp + 1;
      let lastRecord = n * rpp;

      if (lastRecord > total) lastRecord = total;
      let pageInfo = null;

      if (this.$data.enablePaging && this.$data.enableRecordsInfoDisplay) {
        pageInfo = firstRecord + ' to ' + lastRecord + ' of ' + total + ' ' + this.$data.rowsPerPageText;
      } else if (!this.$data.enablePaging && this.$data.enableRecordsInfoDisplay) {
        pageInfo = 'Showing 1 to ' +  total + ' of ' + total + ' ' + this.$data.rowsPerPageText;
      }

      return pageInfo;
    },

  },
  watch: {
    GridData: {
      handler: function () {

        if (this.$data.enableFunctionTracing) {
          console.log("**** watch GridData: ****");
        }
        this.gridDataFnc();
      },
      deep: true,
      flush: "post",
    },

    RowsPerPageText: {
      handler: function () {

        if (this.$data.enableFunctionTracing) {
          console.log("**** watch RowsPerPageText: ****");
        }
        this.rowsPerPageTextFnc();
      },
      deep: true,
      flush: "post",
    },

    SearchText: {
      handler: function () {

        if (this.$data.enableFunctionTracing) {
          console.log("**** watch SearchText: ****");
        }
        this.searchTextFnc();
      },
      deep: true,
      flush: "post",
    },

    HeaderArrays: {
      handler: function () {
        if (this.$data.enableFunctionTracing) {
          console.log("**** watch: HeaderArrays: ****");
        }
        this.headerArraysFnc();
      },
      deep: true,
    },

    LeftRightSlots: {
      handler: function () {
        if (this.$data.enableFunctionTracing) {
          console.log("**** watch: LeftRightSlots: ****");
        }
        this.leftRightSlotsFnc();
      },
      deep: true,
    },

    CenterGridSlots: {
      handler: function () {
        if (this.$data.enableFunctionTracing) {
          console.log("**** watch CenterGridSlots: ****");
        }
        this.centerGridSlotsFnc();
      },
      deep: true,
      flush: "post",
    },

    EnableSearching: {
      handler: function (newData) {
        if (this.$data.enableFunctionTracing) {
          console.log("**** watch EnableSearching: ****");
        }
        this.enableSearchingFnc(newData);
      },
      flush: "post",
    },

    EnableSorting: {
      handler: function (newData) {
        if (this.$data.enableFunctionTracing) {
          console.log("**** watch EnableSorting: ****");
        }

        this.enableSortingFnc(newData);
      },
      flush: "post",
    },

    RowsPerPageArray: {
      handler: function () {
        if (this.$data.enableFunctionTracing) {
          console.log("**** watch RowsPerPageArray: ****");
        }
        this.rowsPerPageArrayFnc();
      },
      deep: true,
      flush: "post",
    },

    MaximumPagesInControl: {
      handler: function () {
        if (this.$data.enableFunctionTracing) {
          console.log("**** MaximumPagesInControl: ****");
        }
        this.maximumPagesInControlFnc();
      },
      flush: "post",
    },

    EnableSettings: {
      handler: function () {
        if (this.$data.enableFunctionTracing) {
          console.log("**** EnableSettings: ****");
        }
        this.enableSettingsFnc();
      },
      flush: "post",
    },

    EnableRecordsInfoDisplay: {
      handler: function () {
        if (this.$data.enableFunctionTracing) {
          console.log("**** EnableRecordsInfoDisplay: ****");
        }
        this.enableRecordsInfoDisplayFnc();
      },
      flush: "post",
    },

  },

  methods: {
    // ############################################################
    // ------------------- Created function -----------------------
    // ############################################################

    //This was created to support resetting in the settings
    //modal window control. It is of course also 
    //used in the Vue created() function.
    createdFnc() {

      this.initializeCenterGridSlots();

      if (this.$data.enableFunctionTracing) {
        console.log("**** createdFnc ****");
      }

      this.gridDataFnc();

      if (this.RowsPerPageText) {
        this.rowsPerPageTextFnc();
      }

      if (this.SearchText) {
        this.searchTextFnc();
      }

      if (this.EnablePaging) {
        this.enablePagingFnc(true);
      } else {
        this.enablePagingFnc(false);
      }

      if (this.EnableSearching) {
        this.enableSearchingFnc(true);
      } else {
        this.enableSearchingFnc(false);
      }

      if (this.HeaderArrays) {
        this.headerArraysFnc();
      }

      if (this.LeftRightSlots) {
        this.leftRightSlotsFnc();
      }

      if (this.LeftRightSlots) {
        this.centerGridSlotsFnc();
      }

      if (this.EnableSorting) {
        this.enableSortingFnc(true);
      } else {
        this.enableSortingFnc(false);
      }

      if (this.RowsPerPageArray) {
        this.rowsPerPageArrayFnc();
      }

      if (this.MaximumPagesInControl) {
        this.maximumPagesInControlFnc();
      }

      if (this.EnableSettings) {
        this.enableSettingsFnc();
      }

      if (this.EnableRecordsInfoDisplay) {
        this.enableRecordsInfoDisplayFnc();
      }
    },

    //This initializes the field names associated with
    //slots to a blank string. The user specifies these
    //field names. The map is then updated with the user
    //request.
    initializeCenterGridSlots() {
      this.$data.centerGridSlots = new Map();
      this.$data.centerGridSlots.set('centerGrid0', '');
      this.$data.centerGridSlots.set('centerGrid1', '');
      this.$data.centerGridSlots.set('centerGrid2', '');
      this.$data.centerGridSlots.set('centerGrid3', '');
      this.$data.centerGridSlots.set('centerGrid4', '');
      this.$data.centerGridSlots.set('centerGrid5', '');
      this.$data.centerGridSlots.set('centerGrid6', '');
      this.$data.centerGridSlots.set('centerGrid7', '');
      this.$data.centerGridSlots.set('centerGrid8', '');
      this.$data.centerGridSlots.set('centerGrid9', '');
      this.$data.centerGridSlots.set('centerGrid10', '');
      this.$data.centerGridSlots.set('centerGrid11', '');
      this.$data.centerGridSlots.set('centerGrid12', '');
      this.$data.centerGridSlots.set('centerGrid13', '');
      this.$data.centerGridSlots.set('centerGrid14', '');
      this.$data.centerGridSlots.set('centerGrid15', '');
    },

    //This initializes the sort enabled value used by each
    //slot. Initially, all slots are not sortable. The user
    //specifies values for the slots and passes it as a 
    //property to this component. Once this is done, the 
    //values below are updated.
    initializeLeftRightSlots() {
      this.$data.enableSlotSorting = new Map();
      this.$data.enableSlotSorting.set('leftHeader0', false);
      this.$data.enableSlotSorting.set('leftHeader1', false);
      this.$data.enableSlotSorting.set('leftHeader2', false);
      this.$data.enableSlotSorting.set('leftHeader3', false);
      this.$data.enableSlotSorting.set('leftHeader4', false);
      this.$data.enableSlotSorting.set('leftHeader5', false);
      this.$data.enableSlotSorting.set('leftHeader6', false);
      this.$data.enableSlotSorting.set('leftHeader7', false);
      this.$data.enableSlotSorting.set('leftHeader8', false);
      this.$data.enableSlotSorting.set('leftHeader9', false);

      this.$data.enableSlotSorting.set('rightHeader10', false);
      this.$data.enableSlotSorting.set('rightHeader11', false);
      this.$data.enableSlotSorting.set('rightHeader12', false);
      this.$data.enableSlotSorting.set('rightHeader13', false);
      this.$data.enableSlotSorting.set('rightHeader14', false);
      this.$data.enableSlotSorting.set('rightHeader15', false);
      this.$data.enableSlotSorting.set('rightHeader16', false);
      this.$data.enableSlotSorting.set('rightHeader17', false);
      this.$data.enableSlotSorting.set('rightHeader18', false);
      this.$data.enableSlotSorting.set('rightHeader19', false);

      this.$data.validatedSortFields.set('leftHeader0', '');
      this.$data.validatedSortFields.set('leftHeader1', '');
      this.$data.validatedSortFields.set('leftHeader2', '');
      this.$data.validatedSortFields.set('leftHeader3', '');
      this.$data.validatedSortFields.set('leftHeader4', '');
      this.$data.validatedSortFields.set('leftHeader5', '');
      this.$data.validatedSortFields.set('leftHeader6', '');
      this.$data.validatedSortFields.set('leftHeader7', '');
      this.$data.validatedSortFields.set('leftHeader8', '');
      this.$data.validatedSortFields.set('leftHeader9', '');

      this.$data.validatedSortFields.set('rightHeader10', '');
      this.$data.validatedSortFields.set('rightHeader11', '');
      this.$data.validatedSortFields.set('rightHeader12', '');
      this.$data.validatedSortFields.set('rightHeader13', '');
      this.$data.validatedSortFields.set('rightHeader14', '');
      this.$data.validatedSortFields.set('rightHeader15', '');
      this.$data.validatedSortFields.set('rightHeader16', '');
      this.$data.validatedSortFields.set('rightHeader17', '');
      this.$data.validatedSortFields.set('rightHeader18', '');
      this.$data.validatedSortFields.set('rightHeader19', '');
    },

    // ############################################################
    // ------------------- Watch Support functions ----------------
    // ############################################################

    enableSettingsFnc() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** enableSettingsFnc: ****");
      }
      this.$data.showSettingsIcon = this.EnableSettings;
    },

    enableRecordsInfoDisplayFnc() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** enableRecordsInfoDisplayFnc: ****");
      }
      this.$data.enableRecordsInfoDisplay = this.EnableRecordsInfoDisplay;
    },

    gridDataFnc() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** gridDataFnc: ****");
      }
      if (this.$data.enableDataLog) {
        console.log("CmpGrid.gridDataFnc: this.GridData: ", this.GridData);
      }

      //In the case that this.GridData is updated, and the length of
      //this.GridData.grid.length hasn't changed, then no pagging will
      //take place.
      let localPageGroup = this.$data.currentPageGroup;
      let localBtnNumber = this.$data.selectedBtnNumber;
      let keepPaggingSettings = false;

      if ((this.GridData.grid) && (this.$data.rawGrid)) {

        if (this.GridData.grid.length == this.$data.rawGrid.length) {
          keepPaggingSettings = true;
        }

        if (this.$data.enableDataLog) {
          console.log('this.GridData.grid.length = ', this.GridData.grid.length);
          console.log('this.$data.rawGrid.length = ', this.$data.rawGrid.length);
          console.log('this.$data.currentPageGroup = ', this.$data.currentPageGroup);
          console.log('keepPaggingSettings = ', keepPaggingSettings);
        }

      }

      this.$data.rawGrid = new Array();

      if (this.GridData != null) {

        //When refeshing the data grid, the settings need to be reset since
        //settings is for a specific set of data and fields within the data.
        this.settingsActive = false;
        this.showSettingsModalWindow = false;
        this.turnOffAllFonts();

        if (toRaw(this.GridData).grid != null) {
          if (toRaw(this.GridData).grid.length > 0) {
            toRaw(this.GridData).grid.forEach((element) =>
              this.$data.rawGrid.push(element)
            );

            if (this.$data.enableDataLog) {
              console.log('gridDataFnc() this.rppArray: ', this.rppArray);
              console.log('gridDataFnc() this.$data.rawGrid.length: ', this.$data.rawGrid.length);
              console.log('gridDataFnc() this.$data.rppDefault: ', this.$data.rppDefault);
            }

            //Update the All list item to have the number of 
            //raw records in the GridData.
            for (let i = 0; i < this.rppArray.length; i++) {
              if (this.$data.rppArray[i].display == 'All') {
                this.$data.rppArray[i].records = this.$data.rawGrid.length;
                break;
              }
            }

            for (let i = 0; i < this.rppDefault.length; i++) {
              if (this.$data.rppDefault[i].display == 'All') {
                this.$data.rppDefault[i].records = this.$data.rawGrid.length;
                break;
              }
            }

          } else {
            this.$data.rawGrid = null;
            this.$data.workGrid = null;
            this.$data.displayGrid = null;
          }
        }

        if (
          toRaw(this.GridData).time != null &&
          this.$data.enableDataLog
        ) {
          console.log("this.GridData.time = ", this.GridData.time);
        }
      }

      if (this.$data.rawGrid == null) {
        this.$data.noRecordsFound = true;
      } else if (toRaw(this.$data.rawGrid).length == 0) {
        this.$data.noRecordsFound = true;
      } else {
        this.$data.noRecordsFound = false;
      }

      this.setWorkingGridToRaw();

      if (this.$data.enableSearching == true) {
        if (this.$data.searchString != null) {
          if (this.$data.searchString.length > 0) {
            this.searchTable(this.$data.searchString);
          }
        }
      }

      if (this.$data.enableSorting == true) {
        if (this.$data.fieldSortedOn != null) {
          //Sort raw grid
          this.sortByKey(this.$data.rawGrid);
          //Sort working grid
          this.sortByKey(this.$data.workGrid);
        }
      }

      //This only needs to be executed in the case that pagging Settings need
      //to be updated. 
      if (keepPaggingSettings == false) {
        if (this.$data.enablePaging == true) {
          this.resetPagingState();
        } else {
          this.setDisplayGridToWorking();
        }
      }

      this.setRawGridKeys();
      // This checks for the existence of the header data.
      this.setGridKeysAndHeadersToUse();

      //Every time there is a refresh of the grid, the data type
      //array needs to be reset also.
      this.setDataTypes();

      if (this.LeftRightSlots) {
        this.leftRightSlotsFnc();
      }

      if (this.CenterGridSlots) {
        this.centerGridSlotsFnc();
      }

      //If the page settings are to be kept, use the original
      //group and button number and then update the various
      //indicies.
      if (keepPaggingSettings) {

        this.$data.currentPageGroup = localPageGroup;
        this.$data.selectedBtnNumber = localBtnNumber;
        this.rowIndiciesUpdate();

        if (this.$data.enableDataLog) {
          console.log('--->> End of GridFnc:');
          console.log('this.$data.currentPageGroup = ', this.$data.currentPageGroup);
          console.log('this.$data.selectedBtnNumber = ', this.$data.selectedBtnNumber);
        }

      }

    },

    rowsPerPageTextFnc() {
      if (this.RowsPerPageText) {
        this.$data.rowsPerPageText = this.RowsPerPageText;
      } else {
        this.$data.rowsPerPageText = 'Records';
      }
    },

    searchTextFnc() {
      if (this.SearchText) {
        this.$data.searchText = this.SearchText;
      } else {
        this.$data.searchText = 'Search:';
      }
    },

    enablePagingFnc(newData) {
      if (this.$data.enableFunctionTracing) {
        console.log("**** enablePagingFnc: ****");
      }

      this.$data.enablePaging = newData;
      if (this.$data.enablePaging == true) {
        this.resetPagingState();
      } else {
        this.$data.rppSelected = "All";
        this.setDisplayGridToWorking();
      }
    },

    enableSearchingFnc(newData) {
      if (this.$data.enableFunctionTracing) {
        console.log("**** enableSearchingFnc: ****");
      }

      this.$data.enableSearching = newData;

      if (this.$data.enableSearching == true) {
        this.resetSearchingState();
      } else {
        this.setWorkingGridToRaw();
        this.setDisplayGridToWorking();
        if (this.$data.enablePaging == true) {
          this.resetPagingState();
        }
      }
    },

    enableSortingFnc(newData) {
      if (this.$data.enableFunctionTracing) {
        console.log("**** enableSortingFnc: ****");
      }

      this.$data.enableSorting = newData;
      this.resetSortingState();
    },

    rowsPerPageArrayFnc() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** rowsPerPageArrayFnc: ****");
      }

      this.$data.rppArray = this.$data.rppDefault;

      if (this.RowsPerPageArray != null) {
        if (this.RowsPerPageArray.length > 0) {

          this.$data.rppArray = new Array();

          this.RowsPerPageArray.forEach((element) => {
            this.$data.rppArray.push({ display: element, records: element });
          });
          this.$data.rppArray.push({ display: 'All', records: this.$data.rawGrid.length });
        }
      }
      this.$data.rppSelected = this.$data.rppArray[0].records;
      this.resetPagingState();
    },
    maximumPagesInControlFnc() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** maximumPagesInControlFnc: ****");
      }

      this.$data.maxPPC = this.MaximumPagesInControl;

      if (this.$data.enableDataLog) {
        console.log(
          "maximumPagesInControlFnc(): this.$data.maxPPC = ", this.$data.maxPPC
        );
      }

      this.resetPagingState();
    },

    headerArraysFnc() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** headerArraysFnc ****");
      }
      if (this.$data.enableDataLog) {
        console.log('headerArraysFnc(): this.HeaderArrays: ', this.HeaderArrays);
      }

      this.$data.headerArrays = {
        rawNames: null,
        displayNames: null,
        hoverText: null,
        defaultShow: null,
      };

      this.$data.headerArraysIsWellDefined = this.headerArrayIsWellDefined();

      //Set this.$data.headerArrays.
      if (this.$data.headerArraysIsWellDefined == true) {

        //--------- rawNames

        this.$data.headerArrays.rawNames = new Array();
        this.$data.headerArrays.displayNames = new Array();
        this.$data.headerArrays.hoverText = new Array();
        this.$data.headerArrays.defaultShow = new Array();

        for (let i = 0; i < this.HeaderArrays.length; i++) {

          this.$data.headerArrays.rawNames.push(this.HeaderArrays[i].rawName);
          this.$data.headerArrays.displayNames.push(this.HeaderArrays[i].displayName);
          this.$data.headerArrays.hoverText.push(this.HeaderArrays[i].hoverText);
          this.$data.headerArrays.defaultShow.push(this.HeaderArrays[i].defaultShow);

        }

        if (this.$data.enableDataLog) {
          console.log('this.$data.headerArrays = ', this.$data.headerArrays);
        }

      } //if (this.HeaderArrays != null) {

      this.setGridKeysAndHeadersToUse();
      this.resetSortingState();
      this.resetSearchingState();
      this.setWorkingGridToRaw();
      this.setDisplayGridToWorking();
      this.resetPagingState();
    },

    //This function controls whether or not left and right slot
    //fields are sortable.
    leftRightSlotsFnc() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** leftRightSlotsFnc ****");
      }
      if (this.$data.enableDataLog) {
        console.log('leftRightSlotsFnc(): this.LeftRightSlots: ', this.LeftRightSlots);
      }

      //Initialize this.$data.enableSlotSorting.
      this.initializeLeftRightSlots();

      //Set this.$data.headerArrays.
      if (this.leftRightSlotArrayWellDefined() == true) {

        let leftRightSlots = {
          slot: new Array(),
          enableSorting: new Array(),
          field: new Array(),
        };

        for (let i = 0; i < this.LeftRightSlots.length; i++) {

          leftRightSlots.slot.push(this.LeftRightSlots[i].slot);
          leftRightSlots.enableSorting.push(this.LeftRightSlots[i].enableSorting);
          leftRightSlots.field.push(this.LeftRightSlots[i].field);
        }

        let lrSlotNames = Array.from(this.$data.enableSlotSorting.keys());

        for (let i = 0; i < lrSlotNames.length; i++) {

          for (let k = 0; k < leftRightSlots.slot.length; k++) {
            if (leftRightSlots.slot[k].trim() == lrSlotNames[i]) {

              if (this.fieldValidatesWithGridKeys(leftRightSlots.field[k].trim())) {

                this.$data.validatedSortFields.set(leftRightSlots.slot[k], leftRightSlots.field[k]);
                this.$data.enableSlotSorting.set(leftRightSlots.slot[k], leftRightSlots.enableSorting[k]);

              }
              break;
            }
          }

        }

        if (this.$data.enableDataLog) {
          console.log('this.$data.enableSlotSorting = ', this.$data.enableSlotSorting);
          console.log('this.$data.validatedSortFields = ', this.$data.validatedSortFields);
        }

      } //if (leftRightSlotsIsWellDefined == true)

    },

    //Make sure that the input key field is in this.$data.rawGridKeys.
    fieldValidatesWithGridKeys(keyToValidate) {
      let keyFound = false;
      for (let i = 0; i < this.$data.rawGridKeys.length; i++) {
        if (keyToValidate.trim() == this.$data.rawGridKeys[i].trim()) {
          keyFound = true;
          break;
        }
      }
      return keyFound;
    },

    //This sets up the map this.$data.centerGridSlots so that it has all
    //user specified fields correctly mapped to slots.
    centerGridSlotsFnc() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** centerGridSlotsFnc ****");
      }

      //Initialize the centerGridSlots map.
      this.initializeCenterGridSlots();

      if (this.$data.enableDataLog) {
        console.log('centerGridSlotsFnc(): this.CenterGridSlots: ', this.CenterGridSlots);
        console.log('centerGridSlotsFnc(): this.$data.centerGridSlots: ', this.$data.centerGridSlots);
      }

      let slotNames = Array.from(this.$data.centerGridSlots.keys());

      if (this.CenterGridSlots != null) {
        if (this.CenterGridSlots.length > 0) {
          for (let i = 0; i < this.CenterGridSlots.length; i++) {

            //Loop through all slot names.
            for (let k = 0; k < slotNames.length; k++) {

              if ((this.CenterGridSlots[i].slot != null) && (this.CenterGridSlots[i].field != null)) {

                //The user specified slot name matches a valid slot name in this.CenterGridSlots[i].slot.
                if (slotNames[k] == this.CenterGridSlots[i].slot) {

                  //Make sure that the field is in this.$data.rawGridKeys before setting the centerGridSlots field.
                  if (this.fieldValidatesWithGridKeys(this.CenterGridSlots[i].field)) {
                    this.$data.centerGridSlots.set(slotNames[k], this.CenterGridSlots[i].field);
                    break;
                  }
                }
              }

            }//for (let k = 0;
          }//for (let i = 0;
        }//if (this.CenterGridSlots.length > 0)
      }//if (this.CenterGridSlots != null)

      if (this.$data.enableDataLog) {
        console.log('centerGridSlotsFnc(): this.$data.centerGridSlots: ', this.$data.centerGridSlots);
      }
    },

    headerArrayIsWellDefined() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** headerArrayIsWellDefined ****");
      }

      if (this.$data.enableDataLog) {
        console.log("this.HeaderArrays = ", this.HeaderArrays);
      }

      let propertyWellDefined = false;

      if (this.HeaderArrays != null) {
        if (this.HeaderArrays.length > 0) {

          //Check that all jason object fields are defined.
          for (let i = 0; i < this.HeaderArrays.length; i++) {
            if ((this.HeaderArrays[i].defaultShow != null) &&
              (this.HeaderArrays[i].rawName != null) &&
              (this.HeaderArrays[i].displayName != null) &&
              (this.HeaderArrays[i].hoverText != null)) {
              propertyWellDefined = true;
            }
            else {
              propertyWellDefined = false;
              break;
            }
          }

          if (propertyWellDefined) {
            //Check the integrity of the HeaderArrays passed in, if any.
            for (let i = 0; i < this.HeaderArrays.length; i++) {
              if ((typeof (this.HeaderArrays[i].defaultShow) == 'boolean') &&
                ((typeof (this.HeaderArrays[i].rawName) == 'string') && (this.HeaderArrays[i].rawName.length > 0)) &&
                ((typeof (this.HeaderArrays[i].displayName) == 'string') && (this.HeaderArrays[i].displayName.length > 0)) &&
                ((typeof (this.HeaderArrays[i].hoverText) == 'string') && (this.HeaderArrays[i].hoverText.length > 0))) {
                propertyWellDefined = true;
              }
              else {
                propertyWellDefined = false;
                break;
              }
            }
          } //if (propertyWellDefined)

        }
      }

      return propertyWellDefined;

    },

    //Check that this.LeftRightSlots is well defined. This includes
    //the types of the fiels. The function is used to determine
    //if slot processing is to continue.
    leftRightSlotArrayWellDefined() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** leftRightSlotArrayWellDefined ****");
      }

      if (this.$data.enableDataLog) {
        console.log("this.LeftRightSlots = ", this.LeftRightSlots);
      }

      let propertyWellDefined = false;

      if (this.LeftRightSlots != null) {
        if (this.LeftRightSlots.length > 0) {

          //Check that all jason object fields are defined.
          for (let i = 0; i < this.LeftRightSlots.length; i++) {
            if ((this.LeftRightSlots[i].slot != null) &&
              (this.LeftRightSlots[i].enableSorting != null) &&
              (this.LeftRightSlots[i].field != null)) {

              if ((typeof (this.LeftRightSlots[i].slot) == typeof ('a')) &&
                (typeof (this.LeftRightSlots[i].enableSorting) == typeof (true)) &&
                (typeof (this.LeftRightSlots[i].field) == typeof ('a'))) {

                propertyWellDefined = true;

              } else {
                propertyWellDefined = false;
                break;
              }
            }
            else {
              propertyWellDefined = false;
              break;
            }
          }
        }
      }

      if (this.$data.enableDataLog) {
        console.log("leftRightSlotArrayWellDefined(): propertyWellDefined = ", propertyWellDefined);
      }

      return propertyWellDefined;
    },

    // ###########################################
    // ------------------- SEARCH ----------------
    // ###########################################

    // -------------- Reset Search State

    resetSearchingState() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** resetSearchingState ****");
      }

      this.$data.searchString = null;

    },

    // -------------- Handle Search Event

    handleSearchEvent(event) {
      if (this.$data.enableFunctionTracing) {
        console.log("**** handleSearchEvent ****");
      }

      let searchString = event.target.value.toLowerCase();
      this.$data.searchString = searchString;
      this.searchTable(searchString);

    },

    // -------------- Perform Search

    searchTable(searchString) {
      if (this.$data.enableFunctionTracing) {
        console.log("**** searchTable ****");
      }

      let filterObj = { indicies: new Array(), use: false };

      if (searchString.length > 0) {
        let recordIndex = -1;
        let indiciesFound = new Set();

        //Check that there is data.
        if (this.$data.rawGrid != null) {
          let rawLength = toRaw(this.$data.rawGrid).length;
          if (rawLength > 0) {
            toRaw(this.$data.rawGrid).forEach((element) => {
              recordIndex++;
              this.$data.activeGridKeys_DisplayTable.forEach((keyStr) => {
                if (
                  String(element[keyStr]).toLowerCase().indexOf(searchString) !=
                  -1
                ) {
                  indiciesFound.add(recordIndex);
                }
              });
            });

            filterObj = { indicies: Array.from(indiciesFound), use: true };
          } // if (rawLength > 0)
        } //if (this.$data.rawGrid != null)
      }

      // console.log("filterObj = ", filterObj);
      this.filterWorkGrid(filterObj);
    },

    // ###########################################
    // ------------------- GRID ------------------
    // ###########################################

    // -------------- Working Grid

    setWorkingGridToRaw() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** setWorkingGridToRaw ****");
      }

      this.$data.workGrid = new Array();

      if (this.$data.rawGrid != null) {
        let rawLength = toRaw(this.$data.rawGrid).length;
        if (rawLength > 0) {
          for (let i = 0; i < rawLength; i++) {
            this.$data.workGrid.push(toRaw(this.$data.rawGrid)[i]);
          }
        }
      }
    },

    // -------------- Display Grid

    setDisplayGridToWorking() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** setDisplayGridToWorking ****");
      }

      this.$data.displayGrid = new Array();

      if (this.$data.workGrid != null) {
        let workLength = toRaw(this.$data.workGrid).length;
        if (workLength > 0) {
          for (let i = 0; i < workLength; i++) {
            this.$data.displayGrid.push(toRaw(this.$data.workGrid)[i]);
          }
        }
      }
    },

    // -------------- Set Raw Grid Keys

    //This is only called when grid data is received.
    setRawGridKeys() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** setRawGridKeys ****");
      }

      if (this.$data.rawGrid != null) {
        if (toRaw(this.$data.rawGrid).length > 0) {
          let firstElement = Object.values(this.$data.rawGrid)[0];
          this.$data.rawGridKeys = Object.keys(firstElement);
        }
      }
      if (this.$data.enableDataLog) {
        console.log("this.$data.rawGridKeys = ", this.$data.rawGridKeys);
      }
    },
    //------------------------------------------------
    //------------------------------------------------
    //------------------------------------------------

    //------------------------------------------------
    // -------------- Set Grid Keys and Headers to use
    //------------------------------------------------

    setGridKeysAndHeadersToUse() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** setGridKeysAndHeadersToUse ****");
      }
      if (this.$data.enableDataLog) {
        console.log("this.$data.headerArraysIsWellDefined = ", this.$data.headerArraysIsWellDefined);
      }

      //----------- Set this.$data.activeGridKeys

      this.$data.activeGridKeys = new Array();

      if (this.$data.headerArraysIsWellDefined == true) {

        for (let i = 0; i < this.$data.headerArrays.rawNames.length; i++) {

          if (this.$data.headerArrays.defaultShow[i] == true) {
            this.$data.activeGridKeys.push(this.$data.headerArrays.rawNames[i]);
          }
        }

      } else {
        this.$data.rawGridKeys.forEach((element) =>
          this.$data.activeGridKeys.push(element)
        );
      }

      if (this.$data.enableDataLog) {
        console.log('this.$data.activeGridKeys = ', this.$data.activeGridKeys);
        if (this.$data.headerArrays == null) {
          console.log('this.$data.headerArrays == null');
        } else {
          console.log('this.$data.headerArrays.rawNames = ', this.$data.headerArrays.rawNames);
        }
      }

      //----------- Set header text  and hover tooltips ---

      this.$data.tblHeaders_All = new Array();

      //---------  orderedCustomNames_specified processing
      if (this.$data.headerArraysIsWellDefined == true) {

        for (let i = 0; i < this.$data.headerArrays.displayNames.length; i++) {

          this.$data.tblHeaders_All.push(
            {
              hdrText: this.$data.headerArrays.displayNames[i],
              rawKey: this.$data.headerArrays.rawNames[i],
              hdrHover: this.$data.headerArrays.hoverText[i],
              displayField: this.$data.headerArrays.defaultShow[i],
            });

        }

        if (this.$data.enableDataLog) {
          console.log('this.$data.tblHeaders_All = ', this.$data.tblHeaders_All);
        }


        //---------  orderRawNames_specified processing
      } else {

        //This is what sets the header text and hover text when
        //the Header array is not set in the page which hosts
        //this component.

        let rawLen = this.$data.rawGridKeys.length;

        for (let i = 0; i < rawLen; i++) {

          this.$data.tblHeaders_All.push(
            {
              hdrText: this.$data.rawGridKeys[i],
              rawKey: this.$data.rawGridKeys[i],
              hdrHover: this.$data.rawGridKeys[i],
              displayField: true,
            });
        }
      }

      if (this.$data.enableDataLog) {
        console.log('this.$data.activeGridKeys = ', this.$data.activeGridKeys);
        console.log('this.$data.rawGridKeys = ', this.$data.rawGridKeys);
      }

      this.$data.numberOfFields = 0;
      for (let i = 0; i < this.$data.tblHeaders_All.length; i++) {
        if (this.$data.tblHeaders_All[i].displayField == true) {
          this.$data.numberOfFields++;
        }
      }

      this.$data.numberOfFields++;


      //This is needed in order to set the elements
      //for the settings versions of the arrays set
      //in this method.
      this.setSettings_NameKeyArrays_Full();

    },
    //------------------------------------------------
    //------------------------------------------------
    //------------------------------------------------

    // -------------- Filtering Work Grid

    filterWorkGrid(filterObj) {
      if (this.$data.enableFunctionTracing) {
        console.log("**** filterWorkGrid ****");
      }

      this.$data.noRecordsFound = false;

      let indexArray = toRaw(filterObj.indicies);
      let arrayLength = indexArray.length;
      let useArray = filterObj.use;

      if (useArray == false) {
        this.setWorkingGridToRaw();
        this.setDisplayGridToWorking();
        this.resetPagingState();
      } else if (arrayLength == 0) {
        this.$data.noRecordsFound = true;
        this.$data.workGrid = new Array();
        this.$data.displayGrid = new Array();
      } else {
        this.$data.workGrid = new Array();

        for (let i = 0; i < arrayLength; i++) {
          this.$data.workGrid.push(toRaw(this.$data.rawGrid)[indexArray[i]]);
        }
        if (this.$data.enablePaging == false) {
          this.setDisplayGridToWorking();
        } else {
          this.resetPagingState();
        }
      }
    },

    // ###########################################
    // ---------------- SETTINGS -----------------
    // ###########################################

    //This sets the arrays activeGridKeys_DisplayTable and tblHeaders_DisplayTable
    //to be equal to activeGridKeys and tblHeaders_All.
    setSettings_NameKeyArrays_Full() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** setSettings_NameKeyArrays_Full ****");
      }

      this.$data.activeGridKeys_DisplayTable = new Array();
      this.$data.tblHeaders_DisplayTable = new Array();

      if (this.$data.activeGridKeys != null) {
        if (this.$data.activeGridKeys.length > 0) {
          for (let i = 0; i < this.$data.activeGridKeys.length; i++) {

            this.$data.activeGridKeys_DisplayTable.push(this.$data.activeGridKeys[i]);
          }
        }
      }

      if (this.$data.tblHeaders_All != null) {
        if (this.$data.tblHeaders_All.length > 0) {

          for (let i = 0; i < this.$data.tblHeaders_All.length; i++) {

            if (this.$data.tblHeaders_All[i].displayField == true) {

              this.$data.tblHeaders_DisplayTable.push(
                {
                  hdrText: this.$data.tblHeaders_All[i].hdrText,
                  rawKey: this.$data.tblHeaders_All[i].rawKey,
                  hdrHover: this.$data.tblHeaders_All[i].hdrHover
                });
            }
          }
        }
      }

      if (this.$data.enableDataLog) {
        console.log('this.$data.tblHeaders_DisplayTable = ', this.$data.tblHeaders_DisplayTable);
        console.log('this.$data.activeGridKeys_DisplayTable = ', this.$data.activeGridKeys_DisplayTable);
      }

    },

    //This filters the settings arrays so that they only contain
    //the elements selected by the user (column selections).
    setSettings_NameKeyArrays_Filtered(keyArray) {
      if (this.$data.enableFunctionTracing) {
        console.log("**** setSettings_NameKeyArrays_Filtered ****");
      }
      if (this.$data.enableDataLog) {
        console.log('keyArray = ', keyArray);
        console.log('this.$data.activeGridKeys = ', this.$data.activeGridKeys);
      }

      // for (let j = 0; j < keyArray.length; j++) {
      //   console.log('keyArray[j] =', keyArray[j]);
      // }

      this.$data.activeGridKeys_DisplayTable = new Array();
      this.$data.tblHeaders_DisplayTable = new Array();

      if (keyArray != null) {

        if (keyArray.length > 0) {

          keyArray.forEach(name => {

            //------- start ------

            if (this.$data.tblHeaders_All != null) {
              if (this.$data.tblHeaders_All.length > 0) {

                for (let i = 0; i < this.$data.tblHeaders_All.length; i++) {

                  if (name == this.$data.tblHeaders_All[i].rawKey) {

                    this.$data.tblHeaders_DisplayTable.push(
                      {
                        hdrText: this.$data.tblHeaders_All[i].hdrText,
                        rawKey: this.$data.tblHeaders_All[i].rawKey,
                        hdrHover: this.$data.tblHeaders_All[i].hdrHover
                      });

                    this.$data.activeGridKeys_DisplayTable.push(this.$data.tblHeaders_All[i].rawKey);

                  } // if (name == this.$data.tblHeaders_All[i].hdrText)
                }
              }
            } //if (this.$data.tblHeaders_All != null)

            //------- end -----

          }); //keyArray.forEach


        } // if (keyArray.lenth > 0)
      } //if (keyArray != null)

      if (this.$data.enableDataLog) {
        console.log('this.$data.tblHeaders_DisplayTable = ', this.$data.tblHeaders_DisplayTable);
        console.log('this.$data.activeGridKeys_DisplayTable = ', this.$data.activeGridKeys_DisplayTable);
      }

    },

    //Clear the searching textbox.
    clearSorting() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** clearSorting ****");
      }

      this.$data.searchString = null;
      this.searchTable("");
    },

    // ###########################################
    // ------------------- SORTING ---------------
    // ###########################################

    // -------------- Reset Sorting State

    resetSortingState() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** resetSortingState ****");
      }

      this.$data.fieldSortedOn = null;
      this.$data.selectedTblHeaderIndex = null;
      this.$data.useAscendingSort = true;
    },

    // -------------- Handle Slot Sorts

    handleSlotSort(slotName) {
      if (this.$data.enableFunctionTracing) {
        console.log("**** handleSlotSort ****");
      }
      this.$data.selectedSlotName = slotName;

      if (this.$data.enableDataLog) {
        console.log('handleSlotSort(): slotName = ', slotName);
        console.log('handleSlotSort(): this.$data.selectedSlotName = ', this.$data.selectedSlotName);
        console.log('handleSlotSort(): this.$data.enableSorting = ', this.$data.enableSorting);
        console.log('handleSlotSort(): this.$data.enableSorting = ', this.$data.enableSlotSorting);
      }

      //Turn off non slot sorting.
      this.$data.selectedTblHeaderIndex = -1;

      if (this.$data.enableSorting &&
        this.$data.enableSlotSorting.get(this.$data.selectedSlotName) == true) {

        let sortField = this.$data.validatedSortFields.get(this.$data.selectedSlotName);

        if (this.$data.enableDataLog) {
          console.log('handleSlotSort(): sortField = ', sortField);
          console.log('handleSlotSort(): sortField.length = ', sortField.length);
          console.log('this.$data.rawGridKeys = ', this.$data.rawGridKeys);
        }

        if (sortField.length > 0) {

          //Set sorting direction based on previous sort field used.
          if (sortField != this.$data.fieldSortedOn) {
            this.$data.useAscendingSort = true;
          } else {
            this.$data.useAscendingSort = !this.$data.useAscendingSort;
          }

          this.$data.fieldSortedOn = sortField;

          //Sort raw grid
          this.sortByKey(this.$data.rawGrid);
          //Sort working grid
          this.sortByKey(this.$data.workGrid);

          if (this.$data.enablePaging == false) {
            this.setDisplayGridToWorking();
          } else {
            this.resetPagingState();
          }

        }
      }

    },

    // -------------- Handle Grid Sorts

    handlerHeaderSort(index) {
      if (this.$data.enableFunctionTracing) {
        console.log("**** handlerHeaderSort ****");
      }
      if (this.$data.enableDataLog) {
        console.log('handlerHeaderSort(): this.$data.activeGridKeys = ', this.$data.activeGridKeys);
      }

      //Turn off up/down icon for slot sorting.
      this.$data.selectedSlotName = '';

      if (this.$data.enableSorting == true) {

        let sortField = this.$data.activeGridKeys_DisplayTable[index];

        if (this.$data.enableDataLog) {
          console.log('handlerHeaderSort(): sortField = ', sortField);
        }

        //Set sorting direction based on previous sort field used.
        if (sortField != this.$data.fieldSortedOn) {
          this.$data.useAscendingSort = true;
        } else {
          this.$data.useAscendingSort = !this.$data.useAscendingSort;
        }

        this.$data.fieldSortedOn = sortField;
        this.$data.selectedTblHeaderIndex = index;

        if (this.$data.enableDataLog) {
          console.log('handlerHeaderSort(): this.$data.useAscendingSort = ', this.$data.useAscendingSort);
          console.log('handlerHeaderSort(): this.$data.fieldSortedOn = ', this.$data.fieldSortedOn);
          console.log('handlerHeaderSort(): this.$data.selectedTblHeaderIndex = ', this.$data.selectedTblHeaderIndex);
        }

        //Sort raw grid
        this.sortByKey(this.$data.rawGrid);
        //Sort working grid
        this.sortByKey(this.$data.workGrid);

        if (this.$data.enablePaging == false) {
          this.setDisplayGridToWorking();
        } else {
          this.resetPagingState();
        }
      }
    },

    //Each column in the grid has a header, such as 'Create Date'. In this case the column values
    //are dates. We may have another column, such as 'Note_ID'. In this case the column values are
    //the record key values and are integers. 
    //
    //The purpose of this function is to determine the datatype of each column. When this determination
    //has been made, the results are stored in: 
    //   this.$data.columnTypeArray
    //This array contains a list of javascript objects whose key value pairs look like
    //  {key: 'createDate', type: 'date'}. 
    //There is one object such as this for each column displayed.
    //The columns considered are for
    //   this.$data.displayGrid 
    //which is the grid that is viewed by the user. The array which contains all the display grid's 
    //keys is the one used as the basis of sorting
    //   this.$data.activeGridKeys
    //The activeGridKeys are the raw names such as 'createDate', not pretty names such as 'Create Date'.
    //The raw keys are for indexing into arrays, the pretty keys are just for display.
    setDataTypes() {

      if (this.$data.enableFunctionTracing) {
        console.log("**** setDataTypes ****");
      }
      if (this.$data.enableDataLog) {
        console.log('this.$data.rawGrid = ', this.$data.rawGrid);
      }

      if (this.$data.rawGrid != null) {
        if (this.$data.rawGrid.length > 0) {

          //Checks for '10/25/2000' which is 'MM/DD/YYYY'
          var date_regex = /^\d{2}\/\d{2}\/\d{4}$/;

          let keyVal = null;
          this.$data.columnTypeArray = new Array();

          //Logic:
          // (numericCheck == false) and (dateCheck == false): string type
          // (numericCheck == true) and  (dateCheck == false): numeric type
          // (numericCheck == false) and (dateCheck == true):  date type
          for (let i = 0; i < this.$data.rawGridKeys.length; i++) {

            //These are the column names which act as keys.
            keyVal = this.$data.rawGridKeys[i];

            if (this.$data.enableDataLog) {
              console.log('keyVal = ', keyVal);
            }

            let numericCheck = false;
            let dateCheck = false;
            let stringCheck = false;
            let booleanCheck = false;

            for (let j = 0; j < this.$data.rawGrid.length; j++) {
              let fieldValue = this.$data.rawGrid[j][keyVal];

              if (fieldValue != null) {
                numericCheck = (typeof fieldValue == typeof 1);
                dateCheck = date_regex.test(fieldValue);
                booleanCheck = (typeof fieldValue == typeof true);
                if ((numericCheck == false) && (dateCheck == false) && (booleanCheck == false)) {
                  stringCheck = true;
                }
              }
            }

            if (this.$data.enableDataLog) {
              console.log('numericCheck = ', numericCheck, ' -- dateCheck', dateCheck, ' -- booleanCheck', booleanCheck, ' -- stringCheck', stringCheck, ' -- keyVal = ', keyVal);
            }

            if ((numericCheck == true) && (dateCheck == false) && (booleanCheck == false) && (stringCheck == false)) {
              this.$data.columnTypeArray.push({ key: keyVal, type: 'numeric' });
            } else if ((numericCheck == false) && (dateCheck == true) && (booleanCheck == false) && (stringCheck == false)) {
              this.$data.columnTypeArray.push({ key: keyVal, type: 'date' });
            } else if ((numericCheck == false) && (dateCheck == false) && (booleanCheck == true) && (stringCheck == false)) {
              this.$data.columnTypeArray.push({ key: keyVal, type: 'boolean' });
            } else {
              this.$data.columnTypeArray.push({ key: keyVal, type: 'string' });
            }

          }

          if (this.$data.enableDataLog) {
            console.log('this.$data.columnTypeArray = ', this.$data.columnTypeArray);
          }

        }
      }
    },

    // Used for sorting: 
    //    this.$data.rawGrid
    //    this.$data.workGrid

    //sortByKey sorts the data grid based on the column being sorted on.
    //The column being sorted on is this.$data.fieldSortedOn.
    //The function setDataTypes() determines, for each column in the raw grid,
    //what the data type is that is contained in the column. The data types are
    //  - 'string'
    //  - 'numeric'
    //  - 'date'
    //The array this.$data.columnTypeArray contains the data type
    //for each of the column names (keys) and is set by setDataTypes().
    sortByKey(arryToBeSorted) {
      if (this.$data.enableFunctionTracing) {
        console.log("**** sortByKey ****");
      }

      if (arryToBeSorted != null) {
        let rawLength = toRaw(arryToBeSorted).length;

        if (this.$data.enableDataLog) {
          console.log('rawLength = ', rawLength);
        }

        if (rawLength > 0) {

          let useNumeric = false;
          let useDate = false;
          let useBoolean = false;

          if (this.$data.enableDataLog) {
            console.log('---->>> this.$data.columnTypeArray = ', this.$data.columnTypeArray);
            console.log('this.$data.fieldSortedOn = ', this.$data.fieldSortedOn);
          }

          this.$data.columnTypeArray.forEach((item) => {
            if (item.key == this.$data.fieldSortedOn) {
              if (item.type == 'numeric') {
                useNumeric = true;
              } else if (item.type == 'date') {
                useDate = true;
              } else if (item.type == 'boolean') {
                useBoolean = true;
              }
            }

            if (this.$data.enableDataLog) {
              console.log('item.key = ', item.key, '  --  item.type = ', item.type);
            }

          });

          if (this.$data.enableDataLog) {
            console.log('this.$data.fieldSortedOn = ', this.$data.fieldSortedOn,
              ' -- useNumeric = ', useNumeric, ' -- useDate = ', useDate, ' -- useBoolean = ', useBoolean);
          }

          if (useNumeric) {
            //Numeric sort.
            arryToBeSorted.sort(
              this.$data.useAscendingSort
                ? this.ascNumCompare
                : this.descNumCompare
            );
          } else if (useDate) {
            //Date sort
            arryToBeSorted.sort(
              this.$data.useAscendingSort
                ? this.ascDateCompare
                : this.descDateCompare
            );
          } else if (useBoolean) {
            //Boolean sort.
            arryToBeSorted.sort(
              this.$data.useAscendingSort
                ? this.ascBoolCompare
                : this.descBoolCompare
            );

          } else {
            //String sort.
            arryToBeSorted.sort(
              this.$data.useAscendingSort
                ? this.ascStringCompare
                : this.descStringCompare
            );
          }

        } //if (rawLength > 0)
      } //if (this.$data.rawGrid != null)
    },

    //----------------------------
    //---------- boolean ---------
    //----------------------------
    ascBoolCompare(a, b) {

      if (a[this.$data.fieldSortedOn] == null) {
        return 1;
      }
      if (b[this.$data.fieldSortedOn] == null) {
        return -1;
      }

      return b[this.$data.fieldSortedOn] - a[this.$data.fieldSortedOn];
    },

    // -------------- Sort Compare Descending - non-numeric
    descBoolCompare(a, b) {

      if (a[this.$data.fieldSortedOn] == null) {
        return -1;
      }
      if (b[this.$data.fieldSortedOn] == null) {
        return 1;
      }

      return a[this.$data.fieldSortedOn] - b[this.$data.fieldSortedOn];
    },

    //----------------------------
    //---------- strings ---------
    //----------------------------
    // -------------- Sort Compare Ascending - non-numeric
    ascStringCompare(a, b) {

      //In the case of null, the item is sorted on top.
      if (!a[this.$data.fieldSortedOn]) {
        return 1;
      }
      if (!b[this.$data.fieldSortedOn]) {
        return -1;
      }

      return a[this.$data.fieldSortedOn].localeCompare(
        b[this.$data.fieldSortedOn],
        undefined,
        { sensitivity: "base" }
      );
    },

    // -------------- Sort Compare Descending - non-numeric
    descStringCompare(a, b) {

      //In the case of null, the item is sorted on top.
      if (!a[this.$data.fieldSortedOn]) {
        return -1;
      }
      if (!b[this.$data.fieldSortedOn]) {
        return 1;
      }

      return b[this.$data.fieldSortedOn].localeCompare(
        a[this.$data.fieldSortedOn],
        undefined,
        { sensitivity: "base" }
      );
    },

    //----------------------------
    //---------- numeric ---------
    //----------------------------
    // -------------- Sort Compare Ascending - numeric
    ascNumCompare(a, b) {

      //In the case of null, the item is sorted on top.
      if (!a[this.$data.fieldSortedOn]) {
        return 1;
      }
      if (!b[this.$data.fieldSortedOn]) {
        return -1;
      }

      // console.log(" a = ", a, " -- b = ", " -- (a-b) = ", a - b);
      return a[this.$data.fieldSortedOn] - b[this.$data.fieldSortedOn];
    },

    // -------------- Sort Compare Descending - numeric
    descNumCompare(a, b) {

      //In the case of null, the item is sorted on top.
      if (!a[this.$data.fieldSortedOn]) {
        return -1;
      }
      if (!b[this.$data.fieldSortedOn]) {
        return 1;
      }

      return b[this.$data.fieldSortedOn] - a[this.$data.fieldSortedOn];
    },

    //----------------------------
    //---------- date ------------
    //----------------------------
    // -------------- Sort Compare Ascending - date
    ascDateCompare(a, b) {

      //In the case of null, the item is sorted on top.
      if (!a[this.$data.fieldSortedOn]) {
        return 1;
      }
      if (!b[this.$data.fieldSortedOn]) {
        return -1;
      }

      let dataA = new Date(a[this.$data.fieldSortedOn]);
      let dataB = new Date(b[this.$data.fieldSortedOn]);
      // console.log(" a = ", a, " -- b = ", " -- (a-b) = ", a - b);
      return dataA - dataB;
    },
    // -------------- Sort Compare Descending - date
    descDateCompare(a, b) {

      //In the case of null, the item is sorted on top.
      if (!a[this.$data.fieldSortedOn]) {
        return -1;
      }
      if (!b[this.$data.fieldSortedOn]) {
        return 1;
      }

      let dataA = new Date(a[this.$data.fieldSortedOn]);
      let dataB = new Date(b[this.$data.fieldSortedOn]);

      return dataB - dataA;
    },

    // ###########################################
    // ------------------- PAGING ----------------
    // ###########################################

    // -------------- Reset Paging State

    resetPagingState() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** resetPagingState ****");
      }

      if (this.$data.enablePaging == true) {
        this.initializePageControls();
        this.movePageGroupToFirst();
        this.setFirstLastEnableDisable();
      }
    },

    // -------------- Initialize Page Controls

    initializePageControls() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** initializePageControls ****");
      }

      let totalNumberOfRecords = this.$data.workGrid.length;

      // Total Pages needed.
      let quotient = Math.floor(totalNumberOfRecords / this.$data.rppSelected);
      let remainder = totalNumberOfRecords % this.$data.rppSelected;
      this.$data.totalNumberPages = remainder == 0 ? quotient : quotient + 1;

      // Total Page Groups needed.
      quotient = Math.floor(this.$data.totalNumberPages / this.$data.maxPPC);
      remainder = this.$data.totalNumberPages % this.$data.maxPPC;
      this.$data.pageGroupCount = remainder == 0 ? quotient : quotient + 1;
      this.$data.currentPageGroup = 1;

      this.$data.inFirstGroup = true;
      if (this.$data.pageGroupCount > 1) {
        this.$data.inLastGroup = false;
      }
    },

    // -------------- Compute Indicies to Filter Display Grid

    //Compute the array of indicies for the current page and then
    rowIndiciesUpdate() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** rowIndiciesUpdate() ****");
      }

      let currentPage = this.$data.selectedBtnNumber;
      let maxRowsPerPage = this.$data.rppSelected;

      let firstRecord = (currentPage - 1) * maxRowsPerPage + 1;
      let lastRecord = currentPage * maxRowsPerPage;

      let totalRecords = this.$data.workGrid.length;

      if (lastRecord > totalRecords) {
        lastRecord = totalRecords;
      }

      let indexArray = Array();
      for (let i = firstRecord; i <= lastRecord; i++) {
        indexArray.push(i - 1);
      }

      this.filterDisplayGrid(indexArray);
    },

    // -------------- Filter Display Grid using Indicies Array

    //This function accepts the indicies of the records to be displayed.
    //It uses these indicies to set the rows to display.
    filterDisplayGrid(rowsToDisplay) {
      if (this.$data.enableFunctionTracing) {
        console.log("**** filterDisplayGrid() ****");
      }

      if (rowsToDisplay != null) {
        if (rowsToDisplay.length > 0) {
          let filterLength = rowsToDisplay.length;

          if (filterLength > 0) {
            // let filteredRowsSorted = rowsToDisplay.sort(function (a, b) {
            //   return a - b;
            // });

            let filteredRowsSorted = rowsToDisplay;

            let minIndex = filteredRowsSorted[0];
            let maxIndex = filteredRowsSorted[filteredRowsSorted.length - 1];

            let totalRawRows = this.$data.workGrid.length;

            if (minIndex > -1 && maxIndex < totalRawRows) {
              this.$data.displayGrid = new Array();
              for (let i = 0; i < filterLength; i++) {
                let row = toRaw(this.$data.workGrid)[filteredRowsSorted[i]];
                this.$data.displayGrid.push(row);
              }
            } //if (minIndex > -1 && maxIndex < totalRawRows)
          } //if (filterLength > 0)
        }
      } else {
        this.setDisplayGridToWorking();
      }
    },

    // ---------------------------------------------------
    // ------------- Page Button Clicks  -----------------
    // ---------------------------------------------------

    // -------------------- btnClickHandler ---------------------
    //This is the event handler when a numbered button is clicked.
    btnClickHandler(i_btnNumber) {
      if (this.$data.enableFunctionTracing) {
        console.log("**** btnClickHandler ****");
      }

      this.$data.selectedBtnNumber = i_btnNumber;
      this.rowIndiciesUpdate();
    },

    // ---------------------------------------------------
    // ---------------- MOVE RIGHT  ----------------------
    // ---------------------------------------------------

    btnClickRightEllipsis() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** btnClickRightEllipsis ****");
      }

      if (this.$data.currentPageGroup < this.$data.pageGroupCount) {
        this.$data.currentPageGroup++;
        this.movePageGroupRight();
        this.setFirstLastEnableDisable();
      }
    },

    // -------------------- movePageGroupRight ---------------------
    //Move right to the next page group in sequential order.
    movePageGroupRight() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** movePageGroupRight ****");
      }

      let lastPageNum =
        this.$data.pageCtrlArray[this.$data.pageCtrlArray.length - 1];

      if (lastPageNum != this.$data.totalNumberPages) {
        let newFirstPageNum = lastPageNum + 1;
        let newLastPageNum = newFirstPageNum + this.$data.maxPPC - 1;
        if (newLastPageNum > this.$data.totalNumberPages) {
          newLastPageNum = this.$data.totalNumberPages;
        }

        this.$data.pageCtrlArray = new Array();
        for (let i = newFirstPageNum; i <= newLastPageNum; i++) {
          this.$data.pageCtrlArray.push(i);
        }
        this.$data.firstPageInCurrentGroup = newFirstPageNum;
        this.$data.lastPageInCurrentGroup = newLastPageNum;
        this.$data.selectedBtnNumber = this.firstPageInCurrentGroup;

        this.rowIndiciesUpdate();
      }
    },

    // ---------------------------------------------------
    // ------------------- LAST --------------------------
    // ---------------------------------------------------

    btnClickLast() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** btnClickLast ****");
      }

      this.$data.currentPageGroup = this.$data.pageGroupCount;
      this.movePageGroupToLast();
      this.setFirstLastEnableDisable();
    },

    // -------------------- movePageGroupToLast ---------------------
    //The current page group is set to the last page group.
    movePageGroupToLast() {

      if (this.$data.enableFunctionTracing) {
        console.log("**** movePageGroupToLast ****");
      }

      let groupSize = this.$data.maxPPC;
      let groupMultiplier = this.$data.pageGroupCount - 1;
      let firstPage = groupSize * groupMultiplier + 1;

      // console.log("firstPage = ", firstPage);

      this.$data.firstPageInCurrentGroup = firstPage;
      this.$data.lastPageInCurrentGroup = this.$data.totalNumberPages;
      this.$data.selectedBtnNumber = this.$data.firstPageInCurrentGroup;

      this.$data.pageCtrlArray = Array();
      for (let i = firstPage; i <= this.$data.lastPageInCurrentGroup; i++) {
        this.$data.pageCtrlArray.push(i);
      }
      this.rowIndiciesUpdate();
    },

    // ---------------------------------------------------
    // ------------------- FIRST -------------------------
    // ---------------------------------------------------

    //First button clicked.
    btnClickFirst() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** btnClickFirst ****");
      }

      this.$data.currentPageGroup = 1;
      this.movePageGroupToFirst();
      this.setFirstLastEnableDisable();
    },

    // -------------------- movePageGroupToFirst ---------------------
    //Set the current page group to the first page group.
    movePageGroupToFirst() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** movePageGroupToFirst ****");
      }

      let minPgNum = 1;
      let maxPgNum =
        this.$data.totalNumberPages <= this.$data.maxPPC
          ? this.$data.totalNumberPages
          : this.$data.maxPPC;

      this.$data.pageCtrlArray = Array();
      for (let i = minPgNum; i <= maxPgNum; i++) {
        this.$data.pageCtrlArray.push(i);
      }
      this.$data.firstPageInCurrentGroup = minPgNum;
      this.$data.lastPageInCurrentGroup = maxPgNum;
      this.$data.selectedBtnNumber = this.firstPageInCurrentGroup;
      this.rowIndiciesUpdate();
    },

    // ---------------------------------------------------
    // ---------------- MOVE LEFT  -----------------------
    // ---------------------------------------------------

    btnClickLeftEllipsis() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** btnClickLeftEllipsis ****");
      }

      if (this.$data.currentPageGroup > 1) {
        this.$data.currentPageGroup--;
        this.movePageGroupLeft();
        this.setFirstLastEnableDisable();
      }
    },

    //Move to the previous page group in sequential order.
    movePageGroupLeft() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** movePageGroupLeft ****");
      }

      let firstPageNum = this.$data.pageCtrlArray[0];
      if (firstPageNum != 1) {
        let newLastPageNum = firstPageNum - 1;
        //let newLastPageNum = newFirstPageNum + this.$data.maxPagesInControl - 1;
        let newFirstPageNum = newLastPageNum - this.$data.maxPPC + 1;

        this.$data.pageCtrlArray = new Array();
        for (let i = newFirstPageNum; i <= newLastPageNum; i++) {
          this.$data.pageCtrlArray.push(i);
        }
        this.$data.firstPageInCurrentGroup = newFirstPageNum;
        this.$data.lastPageInCurrentGroup = newLastPageNum;
        this.$data.selectedBtnNumber = this.firstPageInCurrentGroup;

        this.rowIndiciesUpdate();
      }
    },

    // ---------------------------------------------------
    // ------------ Enable First-Last  -------------------
    // ---------------------------------------------------

    //Dynamically enable/disable the First and Last  controls based on the
    //current page number.
    setFirstLastEnableDisable() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** setFirstLastEnableDisable ****");
      }

      if (this.$data.pageGroupCount == 1) {
        this.$data.inFirstGroup = true;
        this.$data.inLastGroup = true;
      } else if (this.$data.currentPageGroup == 1) {
        this.$data.inFirstGroup = true;
        this.$data.inLastGroup = false;
      } else if (
        this.$data.currentPageGroup > 1 &&
        this.$data.currentPageGroup != this.$data.pageGroupCount
      ) {
        this.$data.inFirstGroup = false;
        this.$data.inLastGroup = false;
      } else if (this.$data.currentPageGroup == this.$data.pageGroupCount) {
        this.$data.inFirstGroup = false;
        this.$data.inLastGroup = true;
      }

      // this.logFirstLastEnableDisable();
    },

    // ---------------------------------------------------
    // --------------------- Other  ----------------------
    // ---------------------------------------------------

    // -------------------- setButtonID ---------------------
    //This makes the button IDs alphanumeric based on the button number.
    setButtonID(number) {
      if (this.$data.enableFunctionTracing) {
        console.log("**** setButtonID ****");
      }

      let id = "btn" + number;
      return id;
    },

    rowsPerPageOnchange() {
      console.log('------------->> rowsPerPageOnchange()');
      if (this.$data.enableFunctionTracing) {
        console.log("**** rowsPerPageOnchange ****");
      }
      if (this.$data.enableDataLog) {
        console.log("this.$data.rppSelected = ", this.$data.rppSelected);
      }

      this.resetPagingState();
    },

    // ###########################################
    // ------------------- Modal -----------------
    // ###########################################

    // -------------------------------
    // ---------------- Modal Settings
    // -------------------------------

    //This is called in response to clicking a settings control.
    handleRadioCheckboxClick() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** handleRadioCheckboxClick ****");
      }

      let changesHaveBeenMade = this.changesHaveBeenMadeToControlsInModal();

      if (this.$data.enableDataLog) {
        console.log('handleRadioCheckboxClick(): changesHaveBeenMade = ', changesHaveBeenMade);
      }
      let submitButtonCtrl = document.querySelector('#xcmpgridx-submit-btn-id');
      submitButtonCtrl.disabled = !changesHaveBeenMade;
    },

    //This is called in response to clicking on the settings icon. Doing so
    //opens the settings modal window.
    handleOpenSettingsModal() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** handleOpenSettingsModal ****");
      }

      this.showSettingsModalWindow = true;

      //There is a short delay between setting the v-if condition to be true
      //for the modal window and when the modal window actually exists. This
      //delay is taken care of by using the setTimeout function.
      setTimeout(() => {
        let modalWindow = document.querySelector("#xcmpgridx-CmpGrid-Settings-ID");
        modalWindow.style.display = "block";

        let submitButtonCtrl = document.querySelector('#xcmpgridx-submit-btn-id');
        submitButtonCtrl.disabled = true;

        this.setCheckStateForDynamicHeaderControls();
        this.setCheckboxCheckStateForCmpGridProperties();

        //The last step is to capture all control checked states.
        this.captureStateOfControlsInSettingsModal();

      }, 100);
    },

    captureStateOfControlsInSettingsModal() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** captureStateOfControlsInSettingsModal ****");
      }

      this.$data.settingsControlArray = new Array();

      let searchCheckboxCtrl = document.querySelector('#xcmpgridxSettingsSearchingID');
      let pagingCheckboxCtrl = document.querySelector('#xcmpgridxSettingsPagingID');
      let sortingCheckboxCtrl = document.querySelector('#xcmpgridxSettingsSortingID');

      let smallerCtrl = document.querySelector('#xcmpgrHeaderSmaller');
      let smallCtrl = document.querySelector('#xcmpgrHeaderSmall');
      let mediumCtrl = document.querySelector('#xcmpgrHeaderMedium');
      let largeCtrl = document.querySelector('#xcmpgrHeaderLarge');
      let largerCtrl = document.querySelector('#xcmpgrHeaderLarger');

      let smallerDataCtrl = document.querySelector('#xcmpgrDataSmaller');
      let smallDataCtrl = document.querySelector('#xcmpgrDataSmall');
      let mediumDataCtrl = document.querySelector('#xcmpgrDataMedium');
      let largeDataCtrl = document.querySelector('#xcmpgrDataLarge');
      let largerDataCtrl = document.querySelector('#xcmpgrDataLarger');

      this.$data.settingsControlArray.push({ ctrlID: '#xcmpgridxSettingsSearchingID', checked: searchCheckboxCtrl.checked });
      this.$data.settingsControlArray.push({ ctrlID: '#xcmpgridxSettingsPagingID', checked: pagingCheckboxCtrl.checked });
      this.$data.settingsControlArray.push({ ctrlID: '#xcmpgridxSettingsSortingID', checked: sortingCheckboxCtrl.checked });

      this.$data.settingsControlArray.push({ ctrlID: '#xcmpgrHeaderSmaller', checked: smallerCtrl.checked });
      this.$data.settingsControlArray.push({ ctrlID: '#xcmpgrHeaderSmall', checked: smallCtrl.checked });
      this.$data.settingsControlArray.push({ ctrlID: '#xcmpgrHeaderMedium', checked: mediumCtrl.checked });
      this.$data.settingsControlArray.push({ ctrlID: '#xcmpgrHeaderLarge', checked: largeCtrl.checked });
      this.$data.settingsControlArray.push({ ctrlID: '#xcmpgrHeaderLarger', checked: largerCtrl.checked });

      this.$data.settingsControlArray.push({ ctrlID: '#xcmpgrDataSmaller', checked: smallerDataCtrl.checked });
      this.$data.settingsControlArray.push({ ctrlID: '#xcmpgrDataSmall', checked: smallDataCtrl.checked });
      this.$data.settingsControlArray.push({ ctrlID: '#xcmpgrDataMedium', checked: mediumDataCtrl.checked });
      this.$data.settingsControlArray.push({ ctrlID: '#xcmpgrDataLarge', checked: largeDataCtrl.checked });
      this.$data.settingsControlArray.push({ ctrlID: '#xcmpgrDataLarger', checked: largerDataCtrl.checked });

      // These are the controls which are dynamically created within the modal window.
      let dynamicControls = this.getAllDynamicControlsInModal();
      dynamicControls.forEach((ctrl) => {
        this.$data.settingsControlArray.push({ ctrlID: '#' + ctrl.ctrID, checked: ctrl.ctrObj.checked });
      });

      if (this.$data.enableDataLog) {
        console.log('this.$data.settingsControlArray = ', this.$data.settingsControlArray);
      }

    },

    //This gets all the controls which are dynamically generated. This list
    //includes the column checkbox controls.
    getAllDynamicControlsInModal() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** getAllDynamicControlsInModal ****");
      }

      let dynControls = new Array();

      for (let i = 0; i < this.$data.tblHeaders_All.length; i++) {

        let id = 'ckbx' + this.$data.tblHeaders_All[i].rawKey + 'ID';
        let checkboxCtrl = document.querySelector('#' + id);

        dynControls.push({ ctrObj: checkboxCtrl, ctrID: id });
      }

      return dynControls;
    },

    //This returns true if one of the checkboxes has an altered check state
    //when compared to the check states of all checkboxes when the modal
    //was first opened.
    changesHaveBeenMadeToControlsInModal() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** changesHaveBeenMadeToControlsInModal ****");
      }

      let changeFound = false;

      if (this.$data.enableDataLog) {
        console.log('changesHaveBeenMadeToControlsInModal(): this.$data.settingsControlArray',
          this.$data.settingsControlArray);
      }

      for (let i = 0; i < this.$data.settingsControlArray.length; i++) {

        let liveCtrl = document.querySelector(this.$data.settingsControlArray[i].ctrlID);

        if (liveCtrl.checked != this.$data.settingsControlArray[i].checked) {
          changeFound = true;
          return changeFound;
        }

      }

      if (this.$data.enableDataLog) {
        console.log('changeFound = ', changeFound);
      }

      return changeFound;
    },

    //Check those header controls which are currently being displayed. In other words,
    //for all controls in this.$data.tblHeaders_All, set the checkboxes to be checked.
    setCheckStateForDynamicHeaderControls() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** setCheckStateForDynamicHeaderControls ****");
      }

      if (this.$data.enableDataLog) {
        console.log('this.$data.tblHeaders_All: ', this.$data.tblHeaders_All);
        console.log('this.$data.tblHeaders_DisplayTable: ', this.$data.tblHeaders_DisplayTable);
      }

      for (let i = 0; i < this.$data.tblHeaders_All.length; i++) {

        let keyIsBeingUsed = false;
        for (let j = 0; j < this.$data.tblHeaders_DisplayTable.length; j++) {
          if (this.$data.tblHeaders_DisplayTable[j].hdrText == this.$data.tblHeaders_All[i].hdrText) {
            keyIsBeingUsed = true;
            break;
          }
        }
        let id = 'ckbx' + this.$data.tblHeaders_All[i].rawKey + 'ID';
        let checkboxCtrl = document.querySelector('#' + id);
        checkboxCtrl.checked = keyIsBeingUsed;
      }
    },

    //Based on CmpGrid property values, set the check state of the non-dynamic
    //checkbox controls which correspond to selected property values.
    setCheckboxCheckStateForCmpGridProperties() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** setCheckboxCheckStateForCmpGridProperties ****");
      }

      let searchingCheckboxCtrl = document.querySelector('#xcmpgridxSettingsSearchingID');
      let pagingCheckboxCtrl = document.querySelector('#xcmpgridxSettingsPagingID');
      let sortingCheckboxCtrl = document.querySelector('#xcmpgridxSettingsSortingID');

      let smallerCtrl = document.querySelector('#xcmpgrHeaderSmaller');
      let smallCtrl = document.querySelector('#xcmpgrHeaderSmall');
      let mediumCtrl = document.querySelector('#xcmpgrHeaderMedium');
      let largeCtrl = document.querySelector('#xcmpgrHeaderLarge');
      let largerCtrl = document.querySelector('#xcmpgrHeaderLarger');

      let smallerDataCtrl = document.querySelector('#xcmpgrDataSmaller');
      let smallDataCtrl = document.querySelector('#xcmpgrDataSmall');
      let mediumDataCtrl = document.querySelector('#xcmpgrDataMedium');
      let largeDataCtrl = document.querySelector('#xcmpgrDataLarge');
      let largerDataCtrl = document.querySelector('#xcmpgrDataLarger');

      if (this.$data.enableDataLog) {
        console.log('this.$data.enableSearching = ', this.$data.enableSearching);
        console.log('this.$data.enablePaging = ', this.$data.enablePaging);
        console.log('this.$data.sortingCheckboxCtrl = ', this.$data.enableSorting);
      }

      searchingCheckboxCtrl.checked = this.$data.enableSearching;
      pagingCheckboxCtrl.checked = this.$data.enablePaging;
      sortingCheckboxCtrl.checked = this.$data.enableSorting;

      smallerCtrl.checked = this.$data.headerFontSmaller;
      smallCtrl.checked = this.$data.headerFontSmall;
      mediumCtrl.checked = this.$data.headerFontMedium;
      largeCtrl.checked = this.$data.headerFontLarge;
      largerCtrl.checked = this.$data.headerFontLarger;

      smallerDataCtrl.checked = this.$data.dataFontSmaller;
      smallDataCtrl.checked = this.$data.dataFontSmall;
      mediumDataCtrl.checked = this.$data.dataFontMedium;
      largeDataCtrl.checked = this.$data.dataFontLarge;
      largerDataCtrl.checked = this.$data.dataFontLarger;

    },

    handleCancelButtonClick() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** handleCancelButtonClick ****");
      }

      let modalWindow = document.querySelector("#xcmpgridx-CmpGrid-Settings-ID");
      modalWindow.style.display = "none";

      //This destroys the modal window and all of its controls.
      this.showSettingsModalWindow = false;
    },

    handleSubmitButtonClick() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** handleSubmitButtonClick ****");
      }

      this.settingsActive = true;

      let modalWindow = document.querySelector("#xcmpgridx-CmpGrid-Settings-ID");
      modalWindow.style.display = "none";

      this.processColumnDisplaySelections();
      this.set_Srch_Page_Sort_BasedOnCheckboxes();
      this.set_Font_BasedOnSelection();

      //This destroys the modal window and all of its controls.
      this.showSettingsModalWindow = false;
    },

    set_Font_BasedOnSelection() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** set_Font_BasedOnSelection ****");
      }

      let smallerCtrl = document.querySelector('#xcmpgrHeaderSmaller');
      let smallCtrl = document.querySelector('#xcmpgrHeaderSmall');
      let mediumCtrl = document.querySelector('#xcmpgrHeaderMedium');
      let largeCtrl = document.querySelector('#xcmpgrHeaderLarge');
      let largerCtrl = document.querySelector('#xcmpgrHeaderLarger');

      if (smallerCtrl.checked) {
        this.$data.headerFontSmall = false;
        this.$data.headerFontMedium = false;
        this.$data.headerFontLarge = false;
        this.$data.headerFontLarger = false;
        this.$data.headerFontSmaller = true;
      } else if (smallCtrl.checked) {
        this.$data.headerFontSmaller = false;
        this.$data.headerFontMedium = false;
        this.$data.headerFontLarge = false;
        this.$data.headerFontLarger = false;
        this.$data.headerFontSmall = true;
      } else if (mediumCtrl.checked) {
        this.$data.headerFontSmaller = false;
        this.$data.headerFontSmall = false;
        this.$data.headerFontLarge = false;
        this.$data.headerFontLarger = false;
        this.$data.headerFontMedium = true;
      } else if (largeCtrl.checked) {
        this.$data.headerFontSmaller = false;
        this.$data.headerFontSmall = false;
        this.$data.headerFontMedium = false;
        this.$data.headerFontLarger = false;
        this.$data.headerFontLarge = true;
      } else if (largerCtrl.checked) {
        this.$data.headerFontSmaller = false;
        this.$data.headerFontSmall = false;
        this.$data.headerFontMedium = false;
        this.$data.headerFontLarge = false;
        this.$data.headerFontLarger = true;
      }

      let smallerDataCtrl = document.querySelector('#xcmpgrDataSmaller');
      let smallDataCtrl = document.querySelector('#xcmpgrDataSmall');
      let mediumDataCtrl = document.querySelector('#xcmpgrDataMedium');
      let largeDataCtrl = document.querySelector('#xcmpgrDataLarge');
      let largerDataCtrl = document.querySelector('#xcmpgrDataLarger');

      if (smallerDataCtrl.checked) {
        this.$data.dataFontSmaller = true;
        this.$data.dataFontSmall = false;
        this.$data.dataFontMedium = false;
        this.$data.dataFontLarge = false;
        this.$data.dataFontLarger = false;
      } else if (smallDataCtrl.checked) {
        this.$data.dataFontSmaller = false;
        this.$data.dataFontSmall = true;
        this.$data.dataFontMedium = false;
        this.$data.dataFontLarge = false;
        this.$data.dataFontLarger = false;
      } else if (mediumDataCtrl.checked) {
        this.$data.dataFontSmaller = false;
        this.$data.dataFontSmall = false;
        this.$data.dataFontMedium = true;
        this.$data.dataFontLarge = false;
        this.$data.dataFontLarger = false;
      } else if (largeDataCtrl.checked) {
        this.$data.dataFontSmaller = false;
        this.$data.dataFontSmall = false;
        this.$data.dataFontMedium = false;
        this.$data.dataFontLarge = true;
        this.$data.dataFontLarger = false;
      } else if (largerDataCtrl.checked) {
        this.$data.dataFontSmaller = false;
        this.$data.dataFontSmall = false;
        this.$data.dataFontMedium = false;
        this.$data.dataFontLarge = false;
        this.$data.dataFontLarger = true;
      }

    },

    processColumnDisplaySelections() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** processColumnDisplaySelections ****");
      }

      let nameArray = new Array();

      for (let i = 0; i < this.$data.tblHeaders_All.length; i++) {

        let name = this.$data.tblHeaders_All[i].rawKey;

        let id = 'ckbx' + name + 'ID';
        let checkboxCtrl = document.querySelector('#' + id);

        if (this.$data.enableDataLog) {
          console.log('checkboxCtrl.checked = ', checkboxCtrl.checked, ' (id = ', id, ')', ' {Name: ', name, '}');
        }

        //Capture the selected columns.
        if (checkboxCtrl.checked) {
          nameArray.push(name);
        }
      }

      if (this.$data.enableDataLog) {
        console.log("nameArray = ", nameArray);
      }

      //When the columns are changed, any sorting in effect may be 
      //against a column that is no longer being displayed. So the
      //sorting needs to be cleared.
      this.clearSorting();

      //Update the settings arrays based on the user's selections.
      this.setSettings_NameKeyArrays_Filtered(nameArray);
    },

    set_Srch_Page_Sort_BasedOnCheckboxes() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** set_Srch_Page_Sort_BasedOnCheckboxes ****");
      }

      let searchingCheckboxCtrl = document.querySelector('#xcmpgridxSettingsSearchingID');
      let pagingCheckboxCtrl = document.querySelector('#xcmpgridxSettingsPagingID');
      let sortingCheckboxCtrl = document.querySelector('#xcmpgridxSettingsSortingID');

      let searching = searchingCheckboxCtrl.checked;
      let paging = pagingCheckboxCtrl.checked;
      let sorting = sortingCheckboxCtrl.checked;

      if (searching) {
        this.enableSearchingFnc(true);
      } else {
        this.enableSearchingFnc(false);
      }

      if (paging) {
        this.enablePagingFnc(true);
      } else {
        this.enablePagingFnc(false);
      }

      if (sorting) {
        this.enableSortingFnc(true);
      } else {
        this.enableSortingFnc(false);
      }

    },

    setSettingsFontArray() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** setSettingsFontArray ****");
      }

      let smallerCtrl = document.querySelector('#xcmpgrHeaderSmaller');
      let smallCtrl = document.querySelector('#xcmpgrHeaderSmall');
      let mediumCtrl = document.querySelector('#xcmpgrHeaderMedium');
      let largeCtrl = document.querySelector('#xcmpgrHeaderLarge');
      let largerCtrl = document.querySelector('#xcmpgrHeaderLarger');

      this.$data.settingsFontArray = new Array();

      this.$data.settingsFontArray.push({ ctrlID: '#xcmpgrHeaderSmaller', checked: smallerCtrl.checked });
      this.$data.settingsFontArray.push({ ctrlID: '#xcmpgrHeaderSmall', checked: smallCtrl.checked });
      this.$data.settingsFontArray.push({ ctrlID: '#xcmpgrHeaderMedium', checked: mediumCtrl.checked });
      this.$data.settingsFontArray.push({ ctrlID: '#xcmpgrHeaderLarge', checked: largeCtrl.checked });
      this.$data.settingsFontArray.push({ ctrlID: '#xcmpgrHeaderLarger', checked: largerCtrl.checked });

      let smallerDataCtrl = document.querySelector('#xcmpgrDataSmaller');
      let smallDataCtrl = document.querySelector('#xcmpgrDataSmall');
      let mediumDataCtrl = document.querySelector('#xcmpgrDataMedium');
      let largeDataCtrl = document.querySelector('#xcmpgrDataLarge');
      let largerDataCtrl = document.querySelector('#xcmpgrDataLarger');

      this.$data.settingsFontArray.push({ ctrlID: '#xcmpgrDataSmaller', checked: smallerDataCtrl.checked });
      this.$data.settingsFontArray.push({ ctrlID: '#xcmpgrDataSmall', checked: smallDataCtrl.checked });
      this.$data.settingsFontArray.push({ ctrlID: '#xcmpgrDataMedium', checked: mediumDataCtrl.checked });
      this.$data.settingsFontArray.push({ ctrlID: '#xcmpgrDataLarge', checked: largeDataCtrl.checked });
      this.$data.settingsFontArray.push({ ctrlID: '#xcmpgrDataLarger', checked: largerDataCtrl.checked });

      if (this.$data.enableDataLog) {
        console.log('setSettingsFontArray(): this.$data.settingsFontArray = ', this.$data.settingsFontArray);
      }

    },

    applySettingsFontArray() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** applySettingsFontArray ****");
      }

      if (this.$data.enableDataLog) {
        console.log('applySettingsFontArray(): this.$data.settingsFontArray = ', this.$data.settingsFontArray);
      }

      for (let i = 0; i < this.$data.settingsFontArray.length; i++) {

        if (this.$data.settingsFontArray[i].ctrlID == '#xcmpgrHeaderSmaller') {
          this.$data.headerFontSmaller = this.$data.settingsFontArray[i].checked;

        } else if (this.$data.settingsFontArray[i].ctrlID == '#xcmpgrHeaderSmall') {
          this.$data.headerFontSmall = this.$data.settingsFontArray[i].checked;

        } else if (this.$data.settingsFontArray[i].ctrlID == '#xcmpgrHeaderMedium') {
          this.$data.headerFontMedium = this.$data.settingsFontArray[i].checked;

        } else if (this.$data.settingsFontArray[i].ctrlID == '#xcmpgrHeaderLarge') {
          this.$data.headerFontLarge = this.$data.settingsFontArray[i].checked;

        } else if (this.$data.settingsFontArray[i].ctrlID == '#xcmpgrHeaderLarger') {
          this.$data.headerFontLarger = this.$data.settingsFontArray[i].checked;

        } else if (this.$data.settingsFontArray[i].ctrlID == '#xcmpgrDataSmaller') {
          this.$data.dataFontSmaller = this.$data.settingsFontArray[i].checked;
        } else if (this.$data.settingsFontArray[i].ctrlID == '#xcmpgrDataSmall') {
          this.$data.dataFontSmall = this.$data.settingsFontArray[i].checked;
        } else if (this.$data.settingsFontArray[i].ctrlID == '#xcmpgrDataMedium') {
          this.$data.dataFontMedium = this.$data.settingsFontArray[i].checked;
        } else if (this.$data.settingsFontArray[i].ctrlID == '#xcmpgrDataLarge') {
          this.$data.dataFontLarge = this.$data.settingsFontArray[i].checked;
        } else if (this.$data.settingsFontArray[i].ctrlID == '#xcmpgrDataLarger') {
          this.$data.dataFontLarger = this.$data.settingsFontArray[i].checked;
        }
      }

      if (this.$data.enableDataLog) {
        console.log('this.$data.headerFontSmaller = ', this.$data.headerFontSmaller);
        console.log('this.$data.headerFontSmall  = ', this.$data.headerFontSmall);
        console.log('this.$data.headerFontMedium = ', this.$data.headerFontMedium);
        console.log('this.$data.headerFontLarge = ', this.$data.headerFontLarge);
        console.log('this.$data.headerFontLarger = ', this.$data.headerFontLarger);
      }

    },

    handleResetSettings() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** handleResetSettings ****");
      }

      this.settingsActive = false;

      let modalWindow = document.querySelector("#xcmpgridx-CmpGrid-Settings-ID");
      modalWindow.style.display = "none";

      this.createdFnc();

      //This destroys the modal window and all of its controls.
      this.showSettingsModalWindow = false;

      this.turnOffAllFonts();
    },

    turnOffAllFonts() {
      if (this.$data.enableFunctionTracing) {
        console.log("**** turnOffAllFonts ****");
      }

      this.$data.headerFontSmaller = false;
      this.$data.headerFontSmall = false;
      this.$data.headerFontMedium = false;
      this.$data.headerFontLarge = false;
      this.$data.headerFontLarger = false;

      this.$data.dataFontSmaller = false;
      this.$data.dataFontSmall = false;
      this.$data.dataFontMedium = false;
      this.$data.dataFontLarge = false;
      this.$data.dataFontLarger = false;
    },
  },
};
</script>

<style scoped>
/* --------------------------------------------- */
/* ------------------ COMP --------------------- */
/* --------------------------------------------- */

.cmpDivMaster {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background-color: rgb(85, 84, 84); */
}

.cmpContainerParent {
  margin: 0px;
  display: grid;
  grid-template-rows: auto auto;
  grid-template-columns: 100%;
  /* background-color: rgb(249, 226, 226); */
  width: 100%;
}

/* ----------------------------------------------- */
/* ------------------ SEARCH --------------------- */
/* ----------------------------------------------- */

.xxyyspaced {
  display: grid;
  grid-template-columns: 50% 50%;
}

.srcContainer {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  margin-top: 0px;
}

.srcContainerAA {
  display: grid;
  grid-template-columns: 10%;
  grid-template-rows: auto;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
}

.srcContainerAB {
  display: grid;
  grid-template-columns: 33% 33% 33%;
  grid-template-rows: auto;
  align-items: center;
  justify-content: center;
  margin-right: 40px;
}

.srcCentralDiv {
  width: 100%;
  /* background-color: lightblue; */
}

.srcDivMarginZero {
  margin: 0px;
}

.srcMarginRightLarge {
  margin-right: 10px;
}

.srcJustify-Content-Right {
  display: flex;
  justify-content: right;
  padding-right: 0px;
}

.srcJustify-Content-Left {
  display: flex;
  justify-content: left;
  align-items: center;
}

/* --------------------------------------------- */
/* ------------------ GRID --------------------- */
/* --------------------------------------------- */

.grdDivMarginTop {
  margin-top: 10px;
  margin-bottom: 0px;
  margin-left: 0px;
  margin-right: 0px;
}

.grdHeader {
  vertical-align: middle;
  text-align: left;
}

.grdSortHeader {
  vertical-align: middle;
}

.grdSortHeader:hover {
  cursor: pointer;
  background-color: rgb(243, 241, 241);
}

.grdImageSizer {
  width: 15px;
  height: 25px;
  margin-left: 15px;
}

/* --- td */

.grdTdLeft {
  text-align: left;
}

.grdTdCenter {
  text-align: center;
}

/* ----------------------------------------------- */
/* ------------------ PAGING --------------------- */
/* ----------------------------------------------- */

/* ################### NEW APPROACH ################### */

.condensedContainerInfo {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: auto;
  width: 100%;
  margin: 0px;
  padding: 0px;
}

.condensedContainerPagingA {
  display: grid;
  grid-template-columns: 30% 70%;
  grid-template-rows: auto;
  width: 100%;
}

.condensedContainerPagingB {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto;
  width: 100%;
}

.pagingOnlyDiv {
  display: flex;
}

.alignAllRight {
  text-align: right; 
  align-items: right; 
  justify-content: right;
}

/* ################### NEW APPROACH ################### */

/* ----------- DEBUG START ------------- */

.pageInfoMargines {
  margin: 0px;
  padding: 0px;
}
.pgeContainerNew {
  display: flex;
  flex-wrap: nowrap;
  margin-top: 0px;
}
.pgeContainerChildrenA {
  display: grid;
  grid-template-columns: 50% 50%;
  grid-template-rows: auto;
  width: 100%;
}

/* ----------- DEBUG END ------------- */

.pgeContainer {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  margin-top: 0px;
}

.pgeContainerA {
  display: grid;
  grid-template-columns: 25% auto 20%;
  grid-template-rows: auto;
  align-items: center;
  justify-content: center;
}

.pgeContainerB {
  display: grid;
  grid-template-columns: 18% 25% auto 20%;
  grid-template-rows: auto;
  align-items: center;
  justify-content: center;
}

.pgeCentralDiv {
  width: 100%;
  /* background-color: lightblue; */
}

.pgeDivBox {
  border: 1px solid #cccccc;
}

.pgeNumbersRow {
  display: flex;
  align-items: center;
  justify-content: center;
}

.pgeJustify-Content-Right {
  display: flex;
  justify-content: right;
  padding-right: 0px;
}

.pgeJustify-Content-Left {
  display: flex;
  justify-content: left;
  align-items: center;
}

.pgeMarginRightLarge {
  margin-right: 10px;
}

.pgeMarginZero {
  margin-right: 0px;
}

.pgeDivBoxBrdRight {
  border-right: 1px solid #cccccc;
}

.pgeDivboxPadding {
  padding-top: 3px;
  padding-bottom: 3px;
  padding-right: 6px;
  padding-left: 6px;
}

.pgeDivBoxBrdLeft {
  border-left: 1px solid #cccccc;
}

.pgeMarginRowsPerPage {
  margin-left: 10px;
  margin-right: 3px;
  margin-top: 0px;
  margin-bottom: 0px;
}

.pgeSelectSizing {
  width: 75px;
}

.pgeBtnPaggingBase {
  background-color: white;
}

.pgeBtnPaggingBase:hover {
  cursor: pointer;
  /* background-color: black; */
  background-image: linear-gradient(#808080, #595959);
  color: white;
  border: 1px solid black;
}

.pgeBtnPaggingSelected {
  /* background-color: rgb(217, 213, 213); */
  border: 1px solid black;
  background-image: linear-gradient(#d9d9d9, #b3b3b3);
}

.pgeBtnPaggingDiableColor {
  color: rgb(139, 138, 138);
}

/* ----------------------------------------------- */
/* ------------------ SETTINGS ------------------- */
/* ----------------------------------------------- */

.xcmpxmodalFontSmaller {
  font-size: 10px;
}

.xcmpxmodalFontSmall {
  font-size: 12px;
}

.xcmpxmodalFontMedium {
  font-size: 16px;
}

.xcmpxmodalFontLarge {
  font-size: 18px;
}

.xcmpxmodalFontLarger {
  font-size: 20px;
}

.forIconSearch {
  margin-left: 5px;
  color: rgb(6, 106, 11);
  cursor: pointer;
  font-size: 30px;
  margin-right: 0px;
}

button:disabled,
button[disabled] {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
}

button:disabled:hover {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
}

/* -------------------------------------------------------------- */
/* ------------------- start modal style ------------------------ */
/* -------------------------------------------------------------- */

option:first-of-type {
  color: blue;
}

/* ---------- containers ---------- */

.xcmpxmodal-container-main {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  padding-top: 50px;
  /* Location of the box */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

.xcmpxmodal-container-content {
  background-color: #fefefe;
  border: 1px inset black;

  margin-top: 0px;
  padding: 20px;

  margin: auto;
  height: 90%;
  width: 900px;
  overflow-y: auto;
  overflow-x: auto;
}

.xcmpxmodal-footer {
  text-align: right;
}

.xcmpxmodal-container-form-font {
  margin: 5px;
  display: grid;
  grid-template-columns: 30% 60%;
  align-items: center;
  justify-content: left;

  /* background-color: lightyellow; */
}

.xcmpxmodal-container-form {
  margin: 5px;
  display: grid;
  grid-template-columns: 60% 10%;
  align-items: center;
  justify-content: left;

  /* background-color: lightyellow; */
}

.xcmpxmodal-container-formAlt {
  margin: 5px;
  display: grid;
  grid-template-columns: 70% 10%;
  align-items: center;
  justify-content: left;

  /* background-color: lightyellow; */
}

/* ---------- header footer ---------- */

.xcmpxmodal-header {
  text-align: left;
  margin-left: 10px;
  font-size: x-large;
}

/* ---------- buttons ---------- */

.xcmpxmodal-button-Radius {
  border-radius: 10px;
}

/* **** cancel btn */

.xcmpxmodal-cancelButton {
  cursor: pointer;
  color: white;
  background: #6d757c;
}

.xcmpxmodal-cancelButton:hover {
  background: #4e5257;
  color: white;
}

/* **** submit btn */

.xcmpxmodal-yesSubmitButton {
  margin-left: 10px;
  background-color: #28a745;
  color: black;
  cursor: pointer;
}

.xcmpxmodal-yesSubmitButton:hover {
  background-color: #1d7832;
  color: white;
}

/* ---------- hr separators ---------- */

.xcmpxmodal-hr-top {
  margin-bottom: 20px;
  background-color: #E6E6E6;
}

/* ---------- content elements ---------- */

.xcmpxmodal-control-labels {
  display: flex;
  align-items: center;
  font-weight: 400;
  color: rgb(2, 2, 175);
}

.xcmpxmodal-content-justify-right {
  display: flex;
  justify-content: right;
  padding-right: 10px;
}

.xcmpxmodal-content-justify-left {
  display: flex;
  justify-content: left;
  align-items: center;
}

/* ---------- font controls ---------- */

.marginLeftFontRadio {
  margin-left: 15px;
}

.marginLeftFontLabel {
  margin-left: 5px;
}


/* --------------------------------------------- */
/* -------------- end Modal style -------------- */
/* --------------------------------------------- */
</style>
